export const LANG_FN_NAME = 'french';
export const LANG_FN_TRANS = {
  'Loading': 'Chargement',
  'Dashboard': 'Tableau de bord',
  'My Equipment': 'Mon équipement / Notre équipement',
  'My Inventory': 'mon inventaire',
  'Reports': 'Rapports',
  'Admin': 'admin',
  'TT Admin': 'TT Administrateur',
  'My Account': 'Mon compte',
  'Help': 'Aidez-moi',
  'Inspections': 'inspections',
  'New Inspection': 'nouvelle inspection',
  'Find & Edit Inspection': 'Trouvez et Modifier l\'inspection',
  'Interpret Inspection': 'Interpréter l\'inspection',
  'Inspection Planning': 'Planification de l\'inspection',
  'Download Android App': 'Télécharger l\'application pour Android',
  'Full History': 'Historique complète',
  'Record an Action': 'Enregistrer une action',
  'Meter Reading': 'Relevé du compteur / Nombres d\'heures',
  'Meter Change': 'Différence d\'heures',
  'Setup New Equipment': 'Configurer des nouveaux équipements',
  'Find & Edit Equipment': 'Trouver et modifier l\'équipement',
  'Relocate Equipment': 'Équipement de déménager',
  'Inventory': 'Inventaire',
  'New Chain or Frame': 'Nouveau train roulant',
  'Inspection Analysis': 'Analyse de l\'inspection',
  'Component Life Performance': 'Cycle de vie des composants',
  'Equipment Without Contacts': 'Équipement Sans contacts',
  'Login Statistics': 'Statistiques de connexion',
  'Fleet Component Forecast': 'Prévision des composants de la flotte',
  'Home': 'Accueil',
  'Customer Contacts': 'Les contacts clients',
  'User Contacts': 'Les contacts de l\'utilisateur',
  'Job Roles': 'Fonction / poste',
  'Components': 'Composants',
  'COMPONENTS': 'COMPOSANTS',
  'Equipment': 'Équipement',
  'Branded Styles': 'Styles de marque',
  'Old Setup': 'Ancienne configuration / Configuration précédente',
  'Preferences': 'Préférences',
  'TrackCommander Documentation': 'TrackCommander Documentation',
  'What\'s New': 'Nouvelles',
  'About': 'À propos',
  'Job Role Setup': 'Configuration du travail de rôle',
  'Job Role Permissions': 'Autorisations d\'emploi de rôle',
  'Job Role Members': 'Les membres du poste de rôle',
  'Position & Job Status': 'Position et statut d\'emploi',
  'Component Types': 'Types de composants',
  'Setup Components': 'Configurer les composants',
  'Wear Limits (A,B,C,X),': 'Limites \'usure (A, B, C, X),',
  'Wear Rate Formulas': 'Formule du niveau d\'usure',
  'Setup Families': 'Configurer groupe de machine ',
  'Setup Makes': 'Configurer les marques',
  'Setup Models': 'Configurer les modèles',
  'Customer': 'Client',
  'User': 'Utilisateur',
  'Search': 'Recherche',
  'Job Site': 'Chantier',
  'Equipment Serial/Unit No': 'Numero de série ou no. d\'unité de la machine',
  'Family': 'Famille',
  'Make': 'Marque  / Fabriquant ',
  'Model': 'Modèle',
  'Fleet Overview': 'Aperçu de la flotte',
  'Filter': 'Filtre',
  'Filter Table': 'Filtrer l\'information',
  'Eval (L)': 'Eval (L)',
  'Eval (R)': 'Eval (R)',
  'Serial No.': 'Numéro de série.',
  'Unit No.': 'No. d\'unité',
  'SMU': 'SMU',
  'LTD': 'LTD',
  'Last Inspection Date': 'Date de la dernière inspection ',
  'Last Inspect Date': 'Date de la dernière inspection ',
  'Back': 'Retour / Retourner à la page précédente',
  'Awaiting Interpretation': 'En attente d\'interprétation',
  'This machine has recently been inspected, but the report is not ready. Once interpreted, your PDF report will be available for download.': 'Cette machine a été récemment inspecté, mais le rapport n\'est pas prêt. Une fois interprété, votre rapport PDF sera disponible pour téléchargement.',
  'Equipment Details': 'Détails de la machine / Détails de l\'équipement',
  'Download Report': 'Télécharger le rapport',
  'Inspection Details': 'Détails de l\'inspection',
  'Find Inspection': 'Trouver l\'inspection',
  'Equipment History': 'Historique de l\'équipement ',
  'Record Action': 'Sauvegarder \'action ',
  'Serial Number': 'Numéro de série',
  'Unit Number': 'Numéro d\'unité',
  'Next Inspection Date': 'Date de la prochaine inspection',
  'N/A': 'N / A',
  'Meter Reading (SMU)': 'Nombre d\'heures sur la machine',
  'Life to Date (LTD)': 'Vie utile à ce jour ',
  'Chain Serial Number (left)': 'No. de série de la chaine gauche ',
  'Frame Serial Number (left)': 'No. de série du chassis gauche ',
  'Chain Serial Number (right)': 'No. de série de la chaine droite',
  'Frame Serial Number (right)': 'No. de série du chassis droite',
  'Left Side Components': 'Composants côté gauche',
  'Worn (%)': 'Usure (%)',
  'Component': 'Composant',
  'Part No.': 'Numéro de pièce',
  'Life Lived (CMU)': 'La vie a vécu (CMU)',
  'Remaining Life (100%)': 'Durée de vie restante sur un composant jusqu\'à ce qu\'il soit 100% usé',
  'Remaining Life (120%)': 'Durée de vie restante sur un composant jusqu\'à ce qu\'il soit 120% usé',
  'Install Date': 'Date d\'installation ',
  'Equipment SMU at Install': 'Nombre d\'heures sur la machine lors de l\'installation ',
  'Component Hours at Install': 'Nombres d\'heures sur les composants au moment de l\'installation ',
  'Right Side Components': 'Les composants du coté droit',
  'Ruler': 'Règle',
  'Create Favourite': 'Créer vos favoris',
  'Component Overview': 'Aperçu des composants',
  'Wear Rate Overview': 'Aperçu du taux d\'usure',
  'Recommendation': 'Recommandation',
  'Status': 'Statut',
  'Position': 'Position',
  'Type': 'Type',
  'Track Roller Values -': 'Suivre les valeurs Roller -',
  'Left': 'Gauche',
  'Right': 'Droite',
  'hrs': 'heures',
  'No': 'Non',
  'Yes': 'Oui',
  'Carrier Roller AVG': 'Rouleaux porteur du haut',
  'Track Roller AVG': 'Niveau d\'usure des rouleaux en moyenne',
  'Track Roller Worst': 'Niveau d\'usure sur le pire rouleau',
  'Outstanding Actions': 'Actions en suspens',
  'Sprocket': 'Barbotin <<sprocket>>',
  'Rear Idler': 'Poulie de tenision <<idler>> arrière ',
  'Front Idler': 'Poulie de tenision <<idler>> avant',
  'Shoe': 'Patins',
  'Bush Turned': 'Bush Tourné',
  'Bush': 'Bague <<bushing>>',
  'Hours on Link': 'Nombre d\'heures sur la maille ',
  'Link': 'Maille',
  'Current SMU/Hourmeter': 'Nombre d\'heures sur la machine',
  'Site': 'Site',
  'Unit': 'Unité',
  'Serial': 'Série',
  'Update to Current Selection': 'Mettre à jour la sélection actuelle',
  'Setup Undercarriage': 'Configurer le train roulant',
  'On Equipment': 'Sur l\'équipement',
  'In Inventory': 'En inventaire ',
  'Setup User': 'configurer un utilisateur',
  'Setup Customer': 'configurer un client',
  'Setup Job Site': 'configurer un chantier',
  'Observation Lists': 'Observations',
  'Measurement Points': 'Endroits de mesure',
  'Switch App': 'Changer d\'application',
  'Dashboard Overview': 'Aperçu du tableau de bord',
  'Enlarge': 'Agrandir',
  'Inspections Performed': 'inspections réalisées',
  'Total cost of all repairs recorded each month for the past year. This does not include cost of new equipment or parts. Filter this data down using the search above.': 'Coût total de toutes les réparations enregistrées chaque mois pour l\'année écoulée. Cela ne comprend pas les frais de nouveaux équipements ou pièces. Filtrer ces données vers le bas en utilisant la recherche ci-dessus.',
  'Total Cost of Repairs': 'Coût total de réparations',
  'The current evaluation of all the components you can view based on their last inspection. Filter this data down using the search above.': 'L\'évaluation actuelle de tous les composants que vous pouvez voir en fonction de leur dernière inspection. Filtrer ces données vers le bas en utilisant la recherche ci-dessus.',
  'Inspections are due by today date. This is based on what you searched for in total and not what you see in this page only.': 'Les inspections sont dues par date d\'aujourd\hui. Ceci est basé sur ce que vous avez recherché au total et pas ce que vous voyez dans cette page ne.',
  'Inspections due': 'date déchéance de l\'inspection',
  'undefined': 'indéfini',
  'Last Inspection SMU/Hourmeter': 'Dernière inspection SMU / Horamètre',
  'SMU/Hourmeter': 'SMU / Horamètre',
  'Fleet Condition': 'Condition de la flotte',
  'Equipment Overview': 'Aperçu général de l\'équipement',
  'Meter Reading (SMU/HourMeter)': 'Nombre d\'heures',
  'Setup Date': 'Date de configuration',
  'Details': 'Détails',
  'Edit': 'Modifier',
  'Interpret': 'Interpréter',
  'Inspection History': 'Historique d\'inspection',
  'Change Meter Unit': 'Compteur d\heure changé',
  'Update Meter': 'Mise à jour du compteur d\'heure',
  'Life Lived': 'Vie utile du train roulant  ',
  'Equipment SMU/Hourmeter at Install': 'Équipement SMU / Compteur d\'heures à l\'installation',
  'Date Installed': 'Date d\'installation',
  'Total Component Repairs Cost (inc. All Components Ever)': 'Coût des réparations total des composants (incluant tous les composants jamais installé)',
  'Total Purchase Cost (inc. Current Components)': 'Coût d\'achat total (incluant les composants en cours)',
  'Right Side Frame': 'Chassis latéral droit',
  'Right Side Chain': 'Chaîne du côté droit',
  'Left Side Frame': 'Chassis latéral gauche',
  'Left Side Chain': 'Chaîne côté gauche',
  'PDF Report': 'Rapport PDF',
  'Tasks': 'Tâches',
  'Change Jobsite': 'Changer de chantier',
  'Setup Equipment': 'Lieu de travail de la machine',
  'Next Inspection': 'prochaine inspection',
  'Brand': 'Marque',
  '(CMU)': '(CMU)',
  '(100% Worn)': '(100% d\'usure)',
  '(120% Worn)': '(120% d\'usure)',
  'Purchase Cost': 'Coût d\'achat',
  'Repairs Cost': 'Coût des réparations',
  'Interpretation': 'Interprétation',
  'Manage Equipment': 'gérer l\'équipement',
  'Meter Reading (SMU/Hourmeter)': 'Relevé de compteur (SMU / Horamètre)',
  'Forward Travel Km': 'Kilometrage parcouru en marche avant ',
  'Reverse Travel Km': 'Kilometrage parcouru en marche arrière',
  'Forward Hours': 'Nombres d\'heures en marche avant ',
  'Reverse Hours': 'Nombres d\'heures en marche arrière',
  'JobSite Comment': 'Commentaire du chantier',
  'Inspection Comment': 'Commentaire de l\'inspection ',
  'Inspector': 'Inspecteur',
  'Inspection Date': 'Date de l\'inspection',
  'Track Sag': 'Fléchissement des chenilles',
  'Cannon Ext.': 'Distance de la barre sortant du tendeur',
  'Dry Joints': 'Joints secs or (mailles secs)  ',
  'Scallop': 'Festonnage',
  'Add Comment': 'Ajouter un commentaire',
  'Interpretation Comment': 'Interprétation du commentaire',
  'Create New Quote': 'Créer une nouvelle soumission ',
  'There are currently no quotes.': 'Il y a présentment pas de soumissions',
  'Quotes': 'Soumissions',
  'Bar Chart': 'Diagramme à bandes',
  'Additional Observations': 'Observations supplémentaires',
  'Audit Log': 'Vérifier le registre ',
  'Quote': 'Soumissions ',
  'Release': 'Libérer vers le programme pour sauvegarder',
  'Release Report to Customer': 'Partager le rapport avec le client',
  'PDF': 'PDF',
  'Depth Gauge': 'Jauge de profondeur',
  'UT': 'Utah',
  'Eval': 'Eval',
  'Change tool': 'changement d\'outil',
  'Add photo': 'Ajouter une photo',
  'CMU': 'CMU',
  'Tool': 'Outil',
  'Residual Life': 'La vie résiduelle',
  'Select Customer': 'Sélectionnez client',
  'Select Filter': 'Sélectionnez Filtre',
  'Customer Notes': 'Notes clients',
  'Add New': 'Ajouter un nouveau',
  'Address To Customer Name': 'Adresse Pour Nom du client',
  'Created Date': 'date de création',
  'Notes': 'Remarques',
  'Created By': 'Créé par',
  'Select Job Site': 'Sélectionner chantier ',
  'Select Equipment': 'Sélectionnez l\'équipement',
  'Next': 'Suivant',
  'Save And Interpret': 'Enregistrer et Interprétez',
  'Change Equipment': 'Changer de machine ',
  'Review & Save': 'Revue et économisez',
  'General Information': 'Informations générales',
  'Abrasive \*': '\* abrasif',
  'Impact \*': 'incidence *',
  'Moisture \*': 'L\'humidité *',
  'Packing \*': 'Matérial compacté dans les mailles',
  'Observations': 'observations',
  'Reverse Travel Kms': 'Kilometrage parcouru en marche arrière',
  'Reverse Travel hrs': 'Nombre d\'heures parcouru en  marche arrière',
  'Inspection Date *': 'Date d\'inspection *',
  'Meter Reading(SMU/Hourmeter) *': 'Lecture du compteur (SMU / Horamètre) *',
  'Inches': 'Pouces',
  'Change Measurement Unit': 'Changer unité de mesure',
  'Photo': 'Photo',
  'Comment': 'Commentaire',
  'Equipment Hours': 'Nombres d\'heures sur l\'équipement',
  'Forward Travel hrs': 'Nombre d\'heures parcouru en marche avant ',
  'Forward Travel Kms': 'Kilometrage parcouru en marche avant',
  'Overall Notes': 'Notes générales',
  'Inspection Notes': 'Observations lors de l\'inspection',
  'Jobsite Notes': 'Observations du chantier',
  'Underfoot Conditions': 'Conditions générales du sol',
  'Left Chain': 'chaîne gauche',
  'Right Chain': 'chaîne droite',
  'Left Frame': 'Chassis gauche',
  'Right Frame': 'Chassis droite',
  'Worn(%)': 'Usure (%) ',
  'Measurement': 'Mesure',
  'MM': 'MM',
  'There are currently no recommendations added for this quote.': 'Il n\'y a présentement aucune recommandation pour ajouter à cette soumissio. ',
  'Calipers': 'Verniers',
  'Pos.': 'Pos.',
  'Pos': 'Pos',
  'Worn': 'Usé',
  'Unsynced Inspections': 'inspections non synchronisé',
  'Workshop Repair Estimates': 'Estimé des réparations en atelier',
  'Evaluation': 'Évaluation',
  'Select Model': 'Sélectionnez le modèle',
  'Select Make': 'Sélectionnez la marque',
  'Jobsite': 'Chantier',
  'Condition': 'État',
  'Actions': 'Actions',
  'How often will you be inspecting this equipment? We will use this to help forecast future inspections.': 'Combien de fois allez-vous inspectez cet équipement? Nous allons utiliser cette information pour faciliter les inspections futures.',
  'Hours per Day': 'Heures par jour',
  'Inspection Planner': 'échéancier de l\'inspection',
  'I will inspect every': 'Je vais inspecter tous les',
  'On average how many days is this equipment in use, and on which days?': 'En moyenne, combien de jours est-ce que cet équipement est utilisé, et durant quels jours?',
  'Sat': 'Sam',
  'Mon': 'Lun',
  'Tue': 'Mar',
  'Wed': 'Mer',
  'Thu': 'Jeu',
  'Fri': 'Ven',
  'New SMU/Hourmeter': 'Nouveau horamètre',
  'What is the old SMU/Hourmeter meter reading?': 'Ancienne lecture du SMU/Horamètre',
  'What is the new meter SMU/Hourmeter reading?': 'Nouvelle lecture du SMU/Horamètre',
  'What is the date of the replacement?': 'Quelle est la date de remplacement?',
  'Old SMU/Hourmeter Reading is required': 'Ancienne lecture du SMU/Horamètre nécessaire',
  'Application': 'Application',
  'Ranking': 'Classement',
  'Machine Status': 'Statut de la machine ',
  'Please select the customer and job site where this equipment is located.': 'S\'il vous plaît sélectionnez le client et le chantier où cet équipement est situé.',
  'Create Equipment': 'Créer équipement',
  'Would you like to setup a new equipment or modify an existing one?': 'Voulez-vous ajouter un nouvel équipement ou modifier un existant?',
  'Modify Existing Equipment': 'Modifier l\'équipement existant',
  'How do you identify this equipment?': 'Comment identifiez-vous cet équipement?',
  'What type of equipment is this?': 'Quel type d\'équipement est-ce?',
  'What is the earliest known SMU/Hourmeter and the date of reading for this equipment?': 'Quel est la plus ancienne lecture d\'horamètre pour cette machine ?',
  'You can attach a photo of this equipment which can be seen throughout the application.': 'Vous pouvez joindre une photo de cet équipement pour visualiser lors de l\'usuge de cette l\'application.',
  'You can also set some aditional details, although this is not required.': 'Détails additionel (pas nécessaire) ',
  'Select Customer & Job Site': 'Sélectionnez le client et le chantier',
  'Additional Information': 'Information additionnelle',
  'Serial / Unit Number': 'Numéro de série / unité',
  'SMU/Hourmeter at Setup': 'Nombre d\'heures à l\'installation',
  'LTD at Setup': 'LTD à l\'installation',
  'Equipment Setup': 'Configuration de l\'équipement',
  'Setup Complete!': 'Installation terminée!',
  'Now that you have setup your equipment, you need to setup the undercarriage for it before you can start recording inspections.': 'Maintenant que vous avez configuré votre équipement, vous devez configurer le train roulant afin de pouvoir sauvegarder les donnés d\'inspection. ',
  'Setup Undercarriage for This Equipment': 'Configurer le train roulant pour cette machine',
  'Setup Another Equipment': 'Configurer d\'autre équipment ',
  'Equipment is not selected!': 'Aucun équipement sélectionné',
  'Chain & Frame Details': 'Information sur le train de roulement ',
  'Life(When installed on equipment)': 'La vie (Lorsqu\'il est installé sur l\'équipement)',
  'SMU/HourMeter and Date validation passed!': 'SMU / hourmeter et validation de date passée!',
  'Date(When installed on equipment)': 'Date (Une fois installé sur l\'équipement)',
  'Equipment SMU/Hourmeter (at install)': 'Nombres d\'heures au moment de l\'installation',
  'Review and Save': 'Revue et sauvegarder',
  'This will setup components on both sides of the undercarriage the same, you can view and edit sides indivdually if they are different': 'Cette section va cnfigurer les deux cotés du train de roulement. Vous pouvez visionner et modifier les cotés  individuellement. ',
  'Chain': 'Chaîne',
  'Please add the components which will go on the chain.': 'S\'il vous plaît ajouter les composants qui vont vont constituer cette chaîne.',
  'Grouser': 'Barres ',
  'Please add the components which will go on the frame.': 'S\'il vous plaît ajouter les composants qui vont sur le chassis du train de roulement',
  'Cost': 'Coût',
  'Validation failed': 'échec de validation',
  'Bushing': 'Bague',
  'Budget Life': 'budget vie',
  'Size': 'Taille',
  'Frame': 'Chassis',
  'Idler': 'Roue folle (idler)',
  'Guard': 'Garde',
  'Track Elongation': 'Allongement des chaines en raison de l\'usure',
  'Carrier Roller': 'Rouleau porteur',
  'Track Roller': 'Rouleux du bas (simple/double)',
  'Hours at Install': 'Nombres d\'heures au moment de l\'installation ',
  'Date at Install': 'Date de l\'installation',
  'Equip. SMU/Hourmeter at install': 'Lecture de l\'horamètre à l\'instalation ',
  'Setup Undercarriage on Equipment': 'Configurer le train roulant ',
  'Hrs': 'heures',
  'Submit': 'Soumettre',
  'Unlock': 'Ouvrir',
  'Validation failed!': 'Echec de validation ',
  'Hours at install': 'Nombres d\'heures à l\'installation ',
  'By changing equipment you will lose all your inputs!': 'En changeoant de machine, vous allez perdre toures vos données',
  'Validation Passed.': 'Validation effectué',
  'Component attached to the system successfully!': 'Ce composant rajouter au système avec succès ',
  'After you have submitted the data first time round, you are unable to setup components on both sides': 'Après avoir soumis les données la première fois, vous ne pouvez pas configurer les composants des deux cotés.',
  'The current evaluation of all the equipment you can view based on their last inspection. Filter this data down using the search above.': 'L\'évaluation actuelle de tous les équipements que vous pouvez voir en fonction de leur dernière inspection. Filtrer ces données vers le bas en utilisant la recherche ci-dessus.',
  'Eval Overview': 'Evaluation générales',
  'Total count of undercarriage inspections performed on a month by month basis. Filter this data down using the search above.': 'Nombre total d\'inspections du train d\'atterrissage effectué sur un mois après mois. Filtrer ces données vers le bas en utilisant la recherche ci-dessus.',
  'JobSite is not selected!': 'Chantier non  sélectionné',
  'Create new system': 'Créer un nouveau système',
  'Update existing': 'Mise à jour d\'un composant existant',
  'Life(When cerated in inventory)': 'La vie (Quand cerated en stock)',
  'Setup Undercarriage In Inventory': 'Configurer le train roulant en inventaire',
  'Model is not selected!': 'Aucun modèle sélectionnée',
  'By changing selection you will lose all your inputs!': 'En changeant la sélection, vous perdrez toutes vos données!',
  'Setup new undercarriage': 'Préparation d\'un nouveau train d\'atterrissage',
  'Previous step validation failed!': 'La validation de l\'étape précédente a échoué!',
  'Warning': 'Attention',
  'Standard Link or Scallop Resistant Link': 'Maille standard ou une maille résistantant au festonnage',
  'Please select the equipment.': 'SVP sélectionner l\'équipement/machine.',
  'You can only change the SMU/Hourmeter, LTD and Date of an existing equipment if there have been NO inspections performed, or actions recorded. If you need to record that a component has been changed, you should record an action against that equipment.': 'Vous ne pouvez changer le SMU / Horamètre, LTD et la date d\'un équipement existant s\'il y a eu des inspections NO effectuées ou actions enregistrées. Si vous devez enregistrer qu\'un composant a été modifié, vous devez enregistrer une action contre cet équipement.',
  'Examiner': 'Examinateur',
  'Reset': 'Réinitialiser',
  'Evaluation (Worst Side)': 'Évaluation (côté pire)',
  'A': 'UNE',
  'B': 'B',
  'C': 'C',
  'X': 'X',
  'Start Date': 'Date de début',
  'End Date': 'Date de fin',
  'Single Flange': 'Rouleau simple',
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': 'sept',
  '8': '8',
  '9': '9',
  'Manage Inspection Types': 'Gérer les types d\'inspection',
  'Left Side': 'Côté gauche',
  'Language': 'Langue',
  'Home Page': 'page d\'accueil',
  'Currency': 'Devise',
  'Unit of Measurement': 'Unité de mesure',
  'Determines how measurements are displayed to you when viewing inspection results, and how a components percentage worn is calculated when you enter a measurement. ': 'Détermine quelles mesures vous sont affichées lors de l\'affichage des résultats d\'inspection, et comment on calcule un pourcentage d\'ususre des composants lorsque vous entrez vos mesures.',
  'Determines how measurements are displayed to you when viewing inspection results, and how a components percentage worn is calculated when you enter a measurement. ,': 'Détermine quelles mesures vous sont affichées lors de l\'affichage des résultats d\'inspection, et comment on calcule un pourcentage d\'ususre des composants lorsque vous entrez vos mesures.',
  'Contact': 'Contact',
  'Full Name': 'Nom complet',
  'Phone Number': 'Numéro de téléphone',
  'Address': 'Adresse',
  'Street Address': 'Adresse de rue',
  'Suburb / City': 'Banlieue / Ville',
  'Post Code': 'code postal',
  'State': 'Province',
  'Country': 'Pays',
  'Dashboard - Fleet Overview': 'Tableau de bord - Vue d\ensemble de la flotte',
  'Millimetres (mm)': 'Millimètres (mm)',
  'Inches (inch)': 'Pouces (inch)',
  'Email Address': 'Addresse courriel',
  'This is the email address that all emails, reports, etc. for your account will be sent to.': 'Ceci est l\'adresse e-mail dont tous les e-mails, rapports, etc. pour votre compte seront envoyé.',
  'Username': 'Nom d\'utilisateur',
  'This is what you use to sign in to both the web application and the mobile application.': 'Ceci est-ce que vous allez utiliser pour vous connecter à la l\'application Web et l\'application mobile',
  'Change Your Password': 'Changez votre mot de passe',
  'This is the password you use to sign in to both the web application and the mobile application to perform inspections on.': 'Ceci est-ce que vous allez utiliser pour vous connecter à la l\'application Web et l\'application mobile',
  'New Password': 'nouveau mot de passe',
  'Repeat New Password': 'Répété le nouveau mot de passe',
  'Update Password': 'Mettre à jour le mot de passe',
  'Inspections Due Emails': 'Courriel d\'alerte d\'inspection ',
  'Determines whether the sending of Inspections Due Emails is enabled or disabled. ': 'Détermine si l\'envoi des alertes d\'inspections par courriel est activée ou désactivée.',
  'Flange width is 5.24 in. (133 mm), New tread diameter is 30.16 in. (766 mm)': 'Bride largeur est de 5,24 in. (133 mm), le nouveau diamètre de la bande de roulement est 30,16 in. (766 mm)',
  'Flange width is 5.21 in. (132.4 mm), New Tread diameter is 29.54 in. (750.2 mm), UT Tool only to determine flange wear only': 'Si la bride de roulement de la roue tendeur est 5.21 pouces (132.4mm), et le diamètre de la bande de roulement est 29.54 pouces (750.2mm), un outil de measure ultrasonique doit être utilisé pour déterminer l\'usure de la bride. ',
  'Measure across 3 teeth': 'Mesure à travers les dents 3',
  'Flange diameter is 12.28 in. (312 mm)': 'Diamètre du rebord',
  'ForwardTravelHours': 'ForwardTravelHours',
  'ReverseTravelHours': 'ReverseTravelHours',

  'ForwardTravelKms': 'ForwardTravelKms',
  'ReverseTravelKms': 'ReverseTravelKms',
  'TrackSagLeft': 'TrackSagLeft',
  'TrackSagRight': 'TrackSagRight',
  'DryJointLeft': 'DryJointLeft',
  'DryJointRight': 'DryJointRight',
  'CannonExtLeft': 'CannonExtLeft',
  'CannonExtRight': 'CannonExtRight',
  'ScallopLeft': 'ScallopLeft',
  'ScallopRight': 'ScallopRight',
  'JobsiteNotes': 'JobsiteNotes',
  'InspectionNotes': 'InspectionNotes',
  'Dealer': 'Marchand',
  'Projected': 'projeté',
  'Difference': 'Différence',
  'Low': 'Faible',
  'High': 'Haute',
  'Medium': 'Moyen',
  'Addition Observation Lists': 'Ajout d\'observation Listes',
  'Title': 'Titre',
  'Image': 'Image',
  'Add Observations': 'Rajouter des observations ',
  'Select equipment to create new inspection': 'Sélectionnez l\'équipement pour créer une nouvelle inspection',
  'Cancel': 'Annuler',
  'Start Inspection': 'Debuter l\'insepction ',
  'Please check your user permissions, Only inspector or super user can create inspections': 'S\'il vous plaît vérifier vos autorisations utilisateur, inspecteur uniquement ou super utilisateur peut créer des inspections',
  'There is no audit history to display.': 'Il n\'y a pas d\'antécédents d\'audit à afficher.',
  'Send Report': 'Envoyer un rapport',
  'Include Quote': 'Inclure une soumission ',
  'Event Time': 'Heure de l\'évènement',
  'Change': 'Changer',
  'Select Email Recipients': 'Sélectionnez les destinataires du courriel',
  'Send': 'Envoyer',
  'Add Recipient': 'Ajouter un destinataire',
  'An Observation Description is required': 'Une description d\'observation est nécessaire',
  'Adding Observation List': 'Ajouter une liste d\'oberservations',
  'Editing Observation List': 'Modifier la liste d\'observations',
  'Save Observation List': 'Enregistrer la liste d\'observation',
  'Name': 'Nom',
  'Background Colour': 'La couleur de fond',
  'Text Colour': 'Couleur du texte',
  'Preview': 'Aperçu',
  'Save': 'sauvegarder',
  'Select System / Component': 'Sélectionnez Système / Composant',
  'Action Informations': 'Informations d\'action',
  'Save Action': 'Enregistrer l\'action',
  'Multiple Component Replacement': 'Remplacement des composants multiples',
  'Part Cost': 'Coût partiel',
  'Labour Cost': 'Coût du travail',
  'MiscCost': 'Couts divers',
  'Note': 'Remarque',
  'Current CMU': 'courant CMU',
  'There is no components on this system, please make sure your undercarriage setup correctly': 'Il y a aucun composants sur ce système, s\'il vous plaît assurez-vous que votre configuration de train roulant est exact. ',
  'Setup new System': 'Configurer un nouveau systéme',
  'Refresh Available Replacement List': 'Refraichir la liste de remplacement ',
  'There are no available replacements fits this component': 'Il y a aucun remplacement disponible qui correspond à ce composant',
  'Select Swap component': 'Sélectionnez le composant déchange',
  'Labour Cost Option': 'Option main d\'oeuvre ',
  'Misc Cost': 'Coûts divers',
  'Date of Action': 'Date d\'action',
  'Times Re-builded / Re-grousered/ Re-sealed': 'Nombres de fois rebatit, re-patiné, refermés',
  'Total Cost': 'Coût total',
  'Customer hourly rate': 'taux horaire client',
  'Uninstall this at SMU/Hourmeter': 'Désinstaller à SMU / Horamètre',
  'Action Against': 'action contre la',
  'Action Histories will be affected by this action': 'L\'historiques d\'action sera affecté par cette action',
  'Disable': 'Désactiver',
  'Enable': 'Activer',
  'Filter By Serial Number': 'Filtrer par numéro de série',
  'CMU (Average)': 'CMU (moyenne)',
  'Part Number': 'Numéro d\'article',
  'CMU (hrs)': 'CMU (h)',
  '%Worn': '%Usé',
  'Action Date': 'Date de l\'action',
  'Latest Action': 'dernières action',
  'Latest Action Date': 'Date de la dernière action',
  'Action Taken': 'Action prise',
  'Date': 'Date',
  'DATE': 'DATE',
  'History': 'Histoire',
  'Relocate System': 'Relocaliser système',
  'System Notes': 'notes sur le système',
  'Update Notes': 'Note de mise à jour',
  'Relocate To Customer': 'Relocaliser au client',
  'Relocate To Jobsite': 'Relocaliser au chantier',
  'Account': 'Compte',
  'General': 'Général',
  'Alerts': 'alertes',
  'Dashboard - Wear Rate Overview': 'Tableau de bord - Aperçu du taux d\'usure',
  'Dashboard - Component Overview': 'Tableau de bord - Vue d\'ensemble des composants',
  'Hours': 'Heures',
  'Days': 'Journées',
  'Weeks': 'Semaines',
  'Months': 'Mois',
  'Delete': 'Supprimer',
  'Additional Observation Lists': 'Listes d\' observations supplémentaires ',
  'Currently there is no observation list configured for this equipment': 'À l\'heure actuelle il a aucune liste d\'observations configurée pour cet équipement ',
  'You are currently missing the': 'Il vous manque actuellement',
  'Your Preferences': 'vos préférences',
  'Customer Name': 'Nom du client',
  'Add': 'Ajouter',
  'Right Side': 'Côté droit',
  'Replace with new Chain and all components': 'Remplacer par la nouvelle chaîne et tous les composants',
  'Replace with Chain from Inventory': 'Remplacer par la chaîne d\'inventaire',
  'Repairs or Replacements of individual Chain Components': 'Les réparations ou remplacements de composants individuels de la chaîne',
  'Replace with New Frame including new components': 'Remplacer par un nouveau cadre comprenant de nouveaux composants',
  'Replace frame from Inventory': 'Remplacer cadre de l\'inventaire',
  'Repair or Replace individual Frame components': 'Réparer ou remplacer des composants individuels du cadre',
  'Replace Frame Components in Bulk': 'Remplacer les composants du châssis en vrac',
  'Which jobsite would you like to move this equipment to?': 'Ce qui vous voulez jobsite déplacer cet équipement?',
  'Update Jobsite': 'Mise à jour Jobsite',
  'SMU Reading is required': 'SMU lecture est nécessaire',
  'New SMU must be greater than previous SMU': 'Nouvelle SMU doit être supérieure à SMU précédente',
  'New BCM must be greater than previous BCM': 'Nouveau BCM doit être supérieure à BCM précédent',
  'New Tonnage must be greater than previous Tonnage': 'La jauge nouvelle doit être supérieure à jauge précédente',
  'New SMU': 'Nouvelle SMU',
  'Old SMU/Hourmeter': 'Old SMU / Horamètre',
  'New SMU/Hourmeter Reading is required': 'Nouvelle SMU / Horamètre lecture est nécessaire',
  'Invalid date: Installation date is before equipment setup date!': 'Date non valide: la date d\'installation est avant la date d\'installation de l\'équipement!',
  'Equipment Setup Date: ': 'Installation du matériel Date:',
  'Invalid SMU/HourMeter Reading: SMU/HourMeter at install cannot be less than': 'Invalide SMU / hourmeter Lecture: SMU / hourmeter à installer ne peut pas être inférieure à',
  'Invalid SMU/HourMeter Reading: For the same date SMU/HourMeter has conflict ': 'Invalide SMU / hourmeter lecture: Pour la même date SMU / hourmeter a conflit ',
  'Invalid SMU/HourMeter: For ': 'Invalide SMU / hourmeter: Pour ',
  ' SMU/HourMeter has conflict ': ' SMU / hourmeter a conflit ',
  'Something is loading please try again after loading completed!': 'Quelque chose chargement s\'il vous plaît essayer à nouveau après le chargement terminé!',
  'You haven\'t recorded any repair costs yet.': 'Vous n\'avez pas enregistré encore des frais de réparation.',
  'Next Inspection Date SMU/Hourmeter': 'Prochain contrôle Date SMU / Horamètre',
  'Next Inspect Date/SMU': 'Prochain contrôle Date/SMU',
  'Overview': 'Aperçu',
  'Graph': 'Graphique',
  'Left Side - Component Wear Graph and Forecast': 'Côté gauche - l\'usure des composants Graphique et prévisions',
  'Right Side - Component Wear Graph and Forecast': 'Côté droit - l\'usure des composants Graphique et prévisions',
  'Last Inspection Date SMU/Hourmeter': 'Dernière inspection Date de SMU / Horamètre',
  'New Thermography Inspection': 'Nouvelle inspection thermographie',
  'Overall Inspection Comment': 'Commentaire Inspection générale',
  'Thermography Inspection': 'thermographie inspection',
  'Jan': 'Jan',
  'Feb': 'fév',
  'Mar': 'Mar',
  'Apr': 'avr',
  'May': 'Mai',
  'Jun': 'juin',
  'Jul': 'juil',
  'Aug': 'août',
  'Sep': 'SEP',
  'Oct': 'oct',
  'Nov': 'nov',
  'Dec': 'déc',
  'Items per page': 'objets par page',
  'Description': 'La description',
  'Currently there is no observation list configured for this inspection and this equipment': 'À l\'heure actuelle il n\'y a pas de liste d\'observation configurée pour cette inspection et cet équipement',
  'Hours remaining until 100% worn': 'Heures restantes jusqu\'à 100% d\'usure',
  'There is no audit history to display': 'Il n\'y a pas d\'antécédents d\'audit pour afficher',
  'Error': 'Erreur',
  'Please release this quote report first': 'S\'il vous plaît publier ce rapport de devis premier',
  'Add Job Site': 'Ajouter site d\'emploi',
  'Return to Undercarriage': 'Retour à Undercarriage',
  'Logout': 'Se déconnecter',
  'Team Administration ': 'administration équipe',
  'A team can be considered either a customer or a dealership. Each team consists of it’s own group of users who have access to equipment within that team': 'Une équipe peut être considérée soit un client ou un concessionnaire. Chaque équipe est composée de son propre groupe d\'utilisateurs qui ont accès à l\'équipement de cette équipe',
  'Add User': 'Ajouter un utilisateur',
  'Add Customer': 'Ajouter client',
  'Users': 'Utilisateurs',
  'Customers': 'Les clients',
  'Dealerships': 'Dealerships',
  'Filter user table': 'Filtre table utilisateur',
  'Full Name ': 'Nom complet',
  'Team': 'Équipe',
  'Access': 'Accès',
  'More': 'Plus',
  'Request New Model': 'Demander un nouveau modèle',
  'LTD is the “Life To Date” of the equipment': 'LTD est la « vie à ce jour » de l\'équipement',
  'This will generally be the same as the SMU/Hour Meter reading': 'Ce sera généralement le même que la lecture de compteurs SMU / heure',
  'If the meter has been changed, LTD shows the actual machine hours where the SMU/Hour Meter will only show the hours since the meter was installed.': 'Si le compteur a été changé, LTD montre les heures réelles de la machine où le compteur SMU / heure seulement affiche les heures que le compteur a été installé.',
  'Date of Reading': 'Date de lecture',
  'Sun': 'Soleil',
  'Undercarriage History ': 'Histoire train de roulement',
  'Select your Equipment ': 'Sélectionnez votre équipement',
  'Please Select': 'Veuillez sélectionner',
  'System S/N': 'Système S / N',
  'Life Lived ': 'La vie a vécu',
  'Life Remaining (100% Worn': 'Durée de vie restante (100% Worn',
  'Projected Hours ': 'Heures prévues',
  'Both': 'Tous les deux',
  'Show All Parts': 'Afficher toutes les pièces',
  'No action taken': 'Pas d\'action prise',
  'Never': 'Jamais',
  'Sent': 'Envoyé',
  'The PDF report has been emailed to all contacts successfully.': 'Le rapport PDF a été envoyé par courriel à tous les contacts avec succès.',
  'Failed to send PDF report. System Error Cannot write the document to memory. Invalid Serial Number Version.': 'Impossible d\'envoyer un rapport PDF. Erreur système ne peut pas écrire le document à la mémoire. Série non valide numéro de version.',
  'Recommendations included in this quote ': 'Les recommandations de cette citation',
  'Distance Unit': 'Distance Unité',
  'Kilometers (km)': 'Kilomètres (km)',
  'Miles (mi)': 'Miles (mi)',
  'Forward Travel': 'Voyage vers l\'avant',
  'Reverse Travel': 'Voyage inverse',
  'Forward': ' Vers l\'avant',
  'Reverse': 'Inverser',
  'Create Thermography Inspection': 'Créer thermographie inspection',
  'Track Sag (mm)': 'Suivre Sag (mm)',
  'Pin Number': 'Code PIN',
  'Therm L/R': 'Therm L / R',
  'Left Side Additional Component': 'Composante additionnelle du côté gauche',
  'No Side Additional Component': 'Aucun composant supplémentaire Side',
  'Right Side Additional Component': 'Composant supplémentaire côté droit',
  'You haven\'t set up any equipment yet.': 'Vous ne l\'avez pas encore créé d\équipement.',
  'You don\'t have any inspection due for the selection.': 'Vous n\'avez pas en raison de l\'inspection pour la sélection.',
  'There are no inspections to display.': 'Il n\'y a pas d\'inspections à afficher.',
  'General Inspections': 'inspections générales',
  'Thermography Inspections': 'thermographie inspections',
  'Both Inspections': 'les deux inspections',
  'Copy to All': 'Copier sur tous',
  'Copy to Right': 'Copier à droite',
  'Done': 'Terminé',
  'Update Equipment': 'Équipement de mise à jour',
  'Undercarriage Inspection': 'inspection train d\'atterrissage',
  'Temperature Inspection': 'Contrôle de la température',
  'Severity': 'Severity',
  'Manage Custom Evaluation': 'Gérer l\'évaluation personnalisée',
  'Set Evaluation Ranges': 'Set Plage d\'évaluation',
  'Set Custom Evaluation Ranges': 'Définir les plages d\'évaluation personnalisés',
  'Select Level': 'Choisir le niveau',
  'Please select individual machine from the search field above.': 'S\'il vous plaît sélectionner machine individuelle à partir du champ de recherche ci-dessus.',
  'Equipment Level Selected': 'Équipement Niveau sélectionné',
  'Select Dealer': 'Sélectionnez Concessionnaire',
  'Select Jobsite': 'Sélectionnez Jobsite',
  'A Range': 'Plage A',
  'B Range': 'B Plage',
  'C Range': 'C Plage',
  'X Range': 'X Plage',
  'Track Shoes': 'Chaussures de piste',
  'Track Rollers': 'galets de chenille',
  'Tumblers': 'gobelets',
  'Front Idlers': 'avant Idlers',
  'Rear Idlers': 'arrière Idlers',
  'Crawler Frame Guide': 'Crawler Guide Frame',
  'A machine with this Serial No and Unit No combination already exists in your Dealer Group. Please contact your Dealer group administrator to be given access to this machine': 'Une machine avec cette série et non Unité combinaison Non existe déjà dans votre groupe revendeur. S\'il vous plaît contacter l\'administrateur du groupe de concessionnaires à donner accès à cette machine',
  'Thermal Images': 'Images thermiques',
  'UT Equivalent': 'équivalent UT',
  'Custom Evaluation ranges do not currently apply to Rope Shovels.': 'gammes sur mesure d\'évaluation ne sont pas applicables actuellement à la corde Pelleteuses.',
  'Additional Unit Number': 'Numéro d\'unité supplémentaire',
  'This equipment has 2 or more inspections': 'This equipment has 2 or more inspections',
  'Serial/Unit Search': 'Recherche de série/d unité',
  'Recalculate & Save': 'Recalculate & Save',
  'No Undercarriage components setup': 'Aucune configuration de composants du train de roulement',
  'Enable Tracking by Distance Travelled': 'Activer le suivi par distance parcourue',
  'Equipment not in Use': 'Équipement non utilisé',
  'Distance': 'Distance',
  'Propel': 'Propulser',
  'Propel %': 'Propulser %',
  'Average Usage': 'Utilisation moyenne',
  'Avg Usage': 'Utilisation moyenne',
  'Residual Hours': 'Heures résiduelles',
  'Replacement Date': 'Date de remplacement',
  'Work Order#': 'Numéro de bon de travail',
  'Work Order': 'Numéro de bon de travail',
  'B/Turn%': '% de rotation du buisson',
  'Res. Life': 'Durée de vie résiduelle',
  'Projected 100%': 'Prévision de 100%',
  'Projected 120%': 'Prévision de 120%',
  'Frame Condition': 'État du châssis',
  'Equipment DOE at Install': 'Distance de l\'équipement sur l\'équipement à l\'installation',
  'Distance Budget': 'Planification de la distance parcourue',
  'Frame Cost': 'Coût du châssis',
  'Frame Repair Cost': 'Coût de réparation du châssis',
  'Frame Configuration': 'Configuration du châssis',
  'Cannon Type': 'Type Canon',
  'Residual Life based on 100% budgeted hours/propel hours': 'Durée de vie résiduelle basée sur 100 % des heures budgétées/heures de propulsion',
  'Residual Life based on 120% budgeted hours/propel hours': 'Durée de vie résiduelle basée sur 120 % des heures budgétées/heures de propulsion',
  'Projected Life based on 100% budgeted hours/propel hours': 'Durée de vie prévue basée sur 100 % des heures budgétées/heures de propulsion',
  'Projected Life based on 120% budgeted hours/propel hours': 'Durée de vie prévue basée sur 120 % des heures budgétées/heures de propulsion',
  'Click to edit condition': 'Cliquez pour modifier la condition',
  'Click to edit': 'Cliquez pour modifier',
  'Click to edit Component': 'Cliquez pour modifier le composant',
  'UC Inspection': 'Inspection UC',
  'Maintenance Inspection': 'Inspection de maintenance',
  'End of Life Inspection': 'Inspection de fin de vie',
  'Last % Worn Forecasted': 'Dernier % usé prévu',
  '% Worn Today': '% usé aujourd\'hui',
  'Distance Difference': 'Différence de distance',
  '%Worn (heading)': '%Usé (en-tête)',
  'Inspection Type': 'Type d\'inspection',
  'AVG Daily Usage': 'Utilisation quotidienne moyenne',
  'Load More': 'Charger plus',
  'Worn Percentage': 'Pourcentage usé',
  'Component Hours': 'Heures de composant',
  'Last Insp. % Worn': 'Dernière inspection % d\'usure',
  'Display Columns for': 'Afficher les colonnes par ?',
  'Action Type': 'Type d\'action',
  'Side': 'Côté',
  'Component Type': 'Type de composant',
  'REFRESH': 'RAFRAÎCHIR',
  'L/H Chain CMU': 'Heures cumulées des composants du côté gauche',
  'R/H Chain CMU': 'Heures cumulées des composants du côté droit',
  'Action Desc': 'Description de l\'action',
  'Entered By': 'Entré par',
  'Entered Date': 'Date d\'entrée',
  'Total': 'Total',
  'TOTAL': 'Total',
  'Rolling': 'Roulement',
  'Stock Cost': 'Coût de stock',
  'Rolling Stock Cost': 'Coût de stock roulant',
  'Chain Cost': 'Coût de la chaîne',
  'Segment Cost': 'Coût du segment',
  'Running Cost': 'Coût de fonctionnement',
  'Cost/Hour': 'Coût par heure',
  'Cost/Km': 'Coût par km',
  'Propel Hrs': 'Heures de propulsion',
  'Reverse Dist. %': 'Pourcentage de retour parcouru',
  'Total Dist.': 'Distance totale',
  'Add Recommendation': 'Ajouter une recommandation',
  'Save Commment': 'Enregistrer le commentaire',
  'Duplicate Inspection': 'Inspection en double',
  'Refresh linked Inspection': 'Rafraîchir l\'inspection liée',
  'Both Side': 'Les deux côtés',
  'Forecast': 'Prévision',
  'Edit Component': 'Modifier le composant',
  'Add Component': 'Ajouter un composant',
  'Inspection Id': 'ID d\'inspection',
  'Enter text here...': 'Entrez le texte ici...',
  'Quotes & Recommendations': 'Devis et recommandations',
  'Equaliser Bar Type': 'Type de barre d\'égalisation',
  'Toe Out': 'Pointe de sortie',
  'Straight': 'Droit',
  'Res. DOC': 'Distance résiduelle sur le composant',
  'Edit Component Type': 'Modifier le type de composant',
  'Answer': 'Réponse',
  'Hourmeter': 'Horamètre',
  'Select Type': 'Sélectionnez le type',
  'Select Status': 'Sélectionnez le statut',
  'Include Inventory on Equipment': 'Inclure l\'inventaire sur l\'équipement',
  'Include Related Models': 'Inclure les modèles liés',
  'Exclude "Scrap"': 'Exclure "Scrap"',
  'Task List': 'Liste de tâches',
  'Chain to Inventory': 'Chaîne à l\'inventaire',
  'Frame to inventory': 'Cadre à l\'inventaire',
  'Idler to Inventory': 'Idler à l\'inventaire',
  'Inventory Report': 'Rapport d\'inventaire',
  'Serial#': 'Numéro de série',
  'Equip unit #': 'Numéro d\'unité d\'équipement',
  'Condition / Hour on Components / Action done': 'Condition / Heure sur les composants / Action effectuée',
  '%Link': '% Lien',
  'Action': 'Actions',
  '% Bush': '% Bague',
  'Warning message': 'Message d\'avertissement',
  'Images': 'Images',
  'Initial cost': 'Coût initial',
  'Repair cost': 'Coût de réparation',
  'Budget': 'Budget',
  'Dist. Budget': 'Budget de distance',
  'Dist. Budget (Km)': 'Budget de distance',
  //Mohit
  //Translation done by mohit french
  'Choose a date': 'Choisissez une date',
  'Select Asset': 'Sélectionner un actif',
  'Component Criticality': 'Criticité du Composant',
  'Select Family': 'Sélectionner Famille',
  'Component List': 'Liste des Composants',
  '% Contribution to UC Eval': '% Contribution à l’Évaluation UC',
  'Fazer': 'Marque',
  'Data de Inspecção': 'Date d’Inspection',
  'No Action': 'Aucune Action',
  'Certo': 'Droit',
  'cadeia de série': 'Numéro de Chaîne',
  'série do quadro': 'Numéro de Châssis',
  'Frame style': 'Style du Cadre',
  'arbusto virado': 'Axe et Bague Tournés',
  'Unidade#': 'N° d’Unité',
  'DG': 'Jauge de Profondeur',
  'R': 'Règle',
  'UK': 'Outil Inconnu',
  'Meter Unit Reading': 'Lecture du Compteur',
  'Site de Trabalho': 'Lieu de Travail',
  'Measurement Point Description': 'Description du point de mesure',
  '% Contribution to Compart': '% Contribution à Compart',
  'Measurement Point List For': 'Liste des points de mesure pour',
  'User Contact': 'Contact Utilisateur',
  'Contains': 'Contient',
  'Add New Customer': 'Ajouter Nouveau Client',
  'User Contact Details': 'Détails du Contact Utilisateur',
  'Customer Level': 'Niveau Client',
  'Job Site Level': 'Niveau du Site',
  'Equipment Level': 'Niveau de l’Équipement',
  'Email': 'Email',
  'Health': 'État',
  'Under Carriage': 'Train de Roulement',
  'Service': 'Service',
  'Please Select a Customer': 'Veuillez sélectionner un client',
  'Update Selected': 'Mettre à jour la sélection',
  'Delete Selected': 'Supprimer la sélection',
  'Select Customer To Add': 'Sélectionner un client à ajouter',
  'Close': 'Fermer',
  'Select Job Site(S) To Add': 'Sélectionner le(s) Site(s) de Travail à Ajouter',
  'Equipments': 'Équipements',
  'Select User To Add': 'Sélectionner un utilisateur à ajouter',
  'Select User(S) To Add': 'Sélectionner les utilisateurs à ajouter',
  'Add New User': 'Ajouter un nouvel utilisateur',
  'Reload': 'Recharger',
  'Export All': 'Exporter tout',
  'Customer Contact Details': 'Détails du contact client',
  'Customer Contact': 'Contact Client',
  'Inspection Types': 'Types d’inspection',
  'Please select a model first': 'Veuillez d’abord sélectionner un modèle',
  'An Inspection Name is required': 'Un nom d’inspection est requis',
  'Inspection': 'Inspection',
  'Manage': 'Gérer',
  'Inspection Name': 'Nom de l’inspection',
  'There is no inspection types configured for ': 'Aucun type d’inspection n’est configuré pour ',
  'Select Additional Observation Level': 'Sélectionner le niveau d’observation supplémentaire',
  'Additional Observation Constraint Filter': 'Filtre de contrainte d’observation supplémentaire',
  'Adding Additional Observation List': 'Ajout de la liste des observations supplémentaires',
  'Editing Additional Observation List': 'Modification de la liste des observations supplémentaires',
  'Select Answer Type': 'Sélectionner le type de réponse',
  'Additional Observation List On Customer': "Liste d'observations supplémentaires sur le client",
  'Add Dealership': 'Ajouter Concessionnaire',
  'Add Dealer Group': 'Ajouter Groupe de Concessionnaires',
  'Job Sites': 'Sites de Travail',
  'Dealer Group': 'Groupe de Concessionnaires',
  'Undercarriage Inspections Due Emails': 'E-mails d’inspections du train de roulement à effectuer',
  'Daily Inspections Due Emails': 'E-mails d’alerte pour les inspections quotidiennes',
  'Alerting a user of any overdue Digital Inspections which have not been completed after 40 hours. ': 'Alerte l’utilisateur de toute inspection numérique en retard qui n’a pas été complétée après 40 heures. ',
  'PIP Emails': 'E-mails PIP',
  'Receive email alerts for PIP’s  ': 'Recevoir des alertes par e-mail pour les PIP ',
  'DFI Emails': 'E-mails DFI',
  'Receive email alerts for DFI’s  ': 'Recevoir des alertes par e-mail pour les DFI ',
  'Leave Approval Emails': 'E-mails d’approbation de congé',
  'NSW': 'NSW',
  'WA': 'WA',
  'Alerts on the Dashboards': 'Alertes sur les Tableaux de Bord',
  'When the box is ticked the alerts will show. ': 'Lorsque la case est cochée, les alertes seront affichées. ',
  'User Preferences': 'Préférences Utilisateur',
  'Undercarriage User Type': 'Type d’Utilisateur Train de Roulement',
  'UC Dashboard Settings': 'Paramètres du Tableau de Bord UC',
  'UC Component Inspection Order': 'Ordre d’Inspection des Composants UC',
  'UC Multiple Measurements': 'Mesures Multiples UC',
  'UC Equipment Conditions': 'Conditions de l’Équipement UC',
  'UC Inspection & Jobsite Comments Display': 'Affichage des Commentaires d’Inspection UC et Site de Travail',
  'Undercarriage Forecast - % Worn Today': 'Prévision Train de Roulement - % d’Usure Aujourd’hui',
  'GET Dashboard Tasks Show/Hide': 'Afficher/Masquer les Tâches du Tableau de Bord GET',
  'Enable Replace Existing tab': 'Activer l’onglet Remplacer existant',
  'UC Equipment Detail Settings': 'Impostazioni Dettaglio Attrezzatura UC',
  'Please refresh the page to see this change': 'Veuillez actualiser la page pour voir ce changement',
  //
  //Aditya
  'Forecast Selection': 'Sélection de Prévision',
  'Preset Forecast Wear Rates': 'Taux d’usure prévisionnels prédéfinis',
  'Usage (Hrs)': 'Utilisation (Heures)',
  'Latest SMU/DOE': 'Dernier SMU/DOE',
  'Average From Last 3 Inspections': 'Moyenne des 3 dernières inspections',
  'Show dates for 100% Worn': 'Afficher les dates pour 100 % d’usure',
  'Preset Averages': 'Moyennes prédéfinies',
  'Safety Factor': 'Facteur de Sécurité',
  'SMU:': 'SMU:',
  'Show dates for 120% Worn': 'Afficher les dates pour 120 % d’usure',
  'Winter': 'Hiver',
  'Summer': 'Été',
  'Shoulder': 'Épaule',
  'Other': 'Autre',
  'Model Level': 'Niveau du Modèle',
  'Machine Level': 'Niveau de la Machine',
  'Last 4th Historical Inspection': '4e Dernière Inspection Historique',
  'DOE:': 'DOE :',
  'Forecast-Settings': 'Prévision-Paramètres',
  'Forecast Method': 'Méthode de Prévision',
  'Forecast Future Service': 'Prévision de Serviçe Futur',
  'Next PM Service': 'Prochain Service PM',
  '2nd PM Service': '2e Service PM',
  'Floating Date': 'Date Flottante',
  'Floating Date 2': 'Date Flottante 2',
  'None': 'Aucun',
  'Latest SMU': 'Dernier SMU',
  'Save/Refresh': 'Enregistrer/Actualiser',
  'Prior Inspect 3': 'Inspect 3 précédent',
  'Prior Inspect 2': 'Inspect 2 précédent',
  'Prior Inspect 1': 'Inspect 1 précédent',
  'Last Inspect': 'Dernière inspection',
  'Avg CMU': 'Moyenne CMU',
  'Per % Wear': 'Par % d\'usure',
  'Avg DOC': 'Moyenne DOC',
  'Date 100% Worn': 'Date 100% usé',
  'Date 120% Worn': 'Date 120% usé',
  'Last Inspection': 'Dernière Inspection',
  'Show Last 4th Historical Inspection': 'Afficher la 4e Dernière Inspection Historique',
  'Planner': 'Planificateur',
  //
  'Fleet Reporting': 'Rapport de flotte',
  'Pre and Post Hire Report': 'Rapport d’évolution avant et après installation',
  'Email Log': 'Journal des e‑mails',
  'Advances Forecasting': 'Prévisions avancées',
  'Inspection Data Export': 'Exportation des données d’inspection',
  'Report Selection': 'Sélectionner le rapport',
  'Inspected machines': 'Machines inspectées',
  'Identified Issues': 'Problèmes identifiés',
  'Track Tensions': 'Tension de la chaîne',
  'Undercarriage Configuration': 'Configuration du train roulant',
  'Dealer Name': 'Nom du concessionnaire',
  'Filter by Component Details': 'Filtrer par détails du composant',
  'Jobsite Type': 'Type de site de travail',
  'Only components currently fitted to equipment': 'Uniquement les composants actuellement installés sur l’équipement.',
  'Export to Excel': 'Exporter vers Excel',
  'Component Performance Details': 'Détails de performance du composant',
  'Averages': 'Moyenne',
  'Part': 'Pièce',
  'Last Worn': 'Dernière usure',
  'Last Eval': 'Dernière évaluation',
  'Projected 100% Hrs': 'Durée de vie projetée à 100 %',
  'Projected 120% Hrs': 'Durée de vie projetée à 120 %',
  'Date Removed': 'Date de retrait',
  'Cost Per Hour': 'Coût par heure',
  'AVG': 'Moyenne',
  'Start date': 'Date de début',
  'Interval': 'Intervalle',
  'Serial No./ Unit No.': 'N° de série / N° d’unité',
  'Totals Only': 'Totaux uniquement',
  'Totals & Details': 'Totaux et détails',
  'OEM Part#': 'Référence OEM',
  'MFR Part#': 'Référence fabricant',
  'Select equipment': 'Sélectionner l’équipement',
  'Meter reading': 'Lecture de compteur',
  'Life to Date': 'Heures totales accumulées',
  'Setup date': 'Date de configuration',
  'Download report': 'Télécharger le rapport',
  'Add Inspection and Comments': 'Ajouter une inspection et des commentaires',
  'log sent': 'Journal envoyé',
  'Report Number': 'Numéro du rapport',
  'Perform Search': 'Rechercher',
  'Report No': 'N° du rapport',
  'Log Date': 'Date du journal',
  'Sent to Address': 'Envoyé à l’adresse',
  'Selection Criteria for Filtering': 'Critères de sélection pour filtrage',
  'Select Brand': 'Sélectionner la marque',
  'Select Year': 'Sélectionner l’année',
  'Select Month': 'Sélectionner le mois',
  'Show and hide columns': 'Afficher et masquer les colonnes',
  'Saved Scenarios for Forecasting': 'Scénarios enregistrés pour prévision',
  'Segments': 'Segments de la roue motrice',
  'Averages for selected data': 'Moyennes des données sélectionnées',
  'Scenario': 'Scénario',
  'Update selection': 'Mettre à jour la sélection',
  'export': 'Exporter',
  'Machine Inspection Data': 'Données d’inspection de la machine',
  'Average Daily Hrs': 'Moyenne d’heures quotidiennes',
  'Average Daily Dist': 'Moyenne de distance quotidienne',
  'Inspection Events': 'Événements d’inspection',
  'Risk Rating': 'Niveau de risque',
  'Inspection Comments': 'Commentaires d’inspection',
  'Recommended Actions': 'Actions recommandées',
  'Your Inspection ID': 'Votre ID d’inspection',
  'Measured Data Part Wear % per Component': 'Données mesurées de l’usure (%) par composant',
  'Bush Turned Left': 'Bague tournée à gauche',
  'Bush Turned Right': 'Bague tournée à droite',
  'Additional unit number': 'Numéro d’unité supplémentaire',
  'BCM at setup': 'BCM lors de la configuration',
  'Tonnage at setup': 'Tonnage lors de la configuration',
  'Choose file': 'Choisir un fichier',
  'No file chosen': 'Aucun fichier choisi',
  'Usage Distance (km) per day': 'Distance d’utilisation (km) par jour',
  'How often will you be inspecting this equipment?': 'À quelle fréquence inspecterez-vous cet équipement ?',
  'You can also set some additional details': 'Vous pouvez également ajouter des détails supplémentaires, bien que ce ne soit pas obligatoire.',
  'Date at install (chain)': 'Date d’installation (chaîne)',
  'SMU on Equipment at Install': 'Compteur SMU lors de l’installation',
  'Historical Hours on Chain at Install': 'Heures historiques de la chaîne à l’installation',
  'Date at Install (Frame)': 'Date d’installation (châssis)',
  'Budget life(Hrs)': 'Durée de vie prévue (heures)',
  'Budget Distance(Km)': 'Distance prévue (km)',
  'Historical Hours on Frame at Install': 'Heures historiques du châssis à l’installation',
  'Date of Setup': 'Date de configuration',
  'Historical Hours on Chain at Setup': 'Heures historiques de la chaîne lors de la configuration',
  'Historical Distance on Chain at Setup': 'Distance historique de la chaîne lors de la configuration',
  'Chain Components': 'Composants de la chaîne',
  'Show Parts Ids': 'Afficher les références des pièces',
  'Job': 'Travail',
  'Cleaner Holes': 'Trous de nettoyage',
  'UnKnown': 'Inconnu',
  'Disabled': 'Désactivé',
  'Edit Observation': 'Modifier l’observation',
  'Update Equipment Status': 'Mettre à jour l’état de l’équipement',
  'Select Equipment Status': 'Sélectionner l’état de l’équipement',
  'Update': 'Mettre à jour',
  'Search WSRE': 'Rechercher atelier de réparation',
  'Job Status': 'Statut du travail',
  'Temperature Inspections': 'Inspection de température',
  'CRACK VIEW': 'Vue des fissures',
  'Search Results': 'Résultats de recherche',
  '# of Cracks': 'Nombre de fissures',
  'Total Crack Length': 'Longueur totale des fissures',
  'Average Crack Length': 'Longueur moyenne des fissures',
  'Fixed': 'Réparé',
  'Hide Favorites': 'Masquer les favoris',
  'Create Favorite': 'Créer un favori',
  'Select family': 'Sélectionner la famille',
  'Select asset Make': 'Sélectionner la marque de l’actif',
  'Select Job site': 'Sélectionner le site de travail',
  'Select Male': 'Sélectionner la marque',
  'Select Component Type': 'Sélectionner le type de composant',
  'Select Asset Type': 'Sélectionner le type d’actif',
  'Asset Serial Number': 'Numéro de série de l’actif',
  'Select Asset Definition': 'Sélectionner la définition de l’actif',
  'Select Serial Number': 'Sélectionner le numéro de série',
  'Select Alt. Number': 'Sélectionner un numéro alternatif',
  'Template': 'Modèle',
  'All': 'Tout',
  'Rest': 'Effacer',
  'Serch': 'Rechercher',
  'Asset View': 'Vue de l’actif',
  'Asset Location History': 'Historique de localisation de l’actif',
  'Crack View': 'Vue des fissures',
  'Asset definition': 'Définition de l’actif',
  'Alt. Serial': 'Numéro alternatif',
  'Imp. Serial': 'N° de série (Imp.)',
  'Life': 'Vie',
  'Residual': 'Résiduel',
  'Total Life': 'Durée de vie totale',
  'Replace Date': 'Date de remplacement',
  'Warranty Status': 'Statut de garantie',
  'Build No': 'Numéro de construction',
  'Next Inspect': 'Prochaine inspection',
  'Flag': 'Drapeau',
  'Please select the customer and job site': 'Veuillez sélectionner le client et le site de travail',
  'What is the earliest known SMU': 'Quelle est la SMU la plus ancienne connue ?',
  'BCM at Setup': 'BCM lors de la configuration',
  'Tonnage at Setup': 'Tonnage lors de la configuration',
  'Tons': 'Tonnes',
  'Choose files': 'Choisir des fichiers',
  'No Files Chosen': 'Aucun fichier choisi',
  'Hours of Use': 'Heures d’utilisation',
  'Per Day': 'Par jour',
  'Tues': 'Mar',
  'Thurs': 'Jeu',
  'Advanced Forecasting': 'Prévisions avancées',
  'Now that you have setup your equipment': 'Maintenant que vous avez configuré votre équipement, vous devez configurer les accessoires avant d’enregistrer des inspections.',
  'Setup Implements for This Equipment': 'Configurer les accessoires pour cet équipement',
  'New Implement': 'Nouvel accessoire',
  'Customer and Jobsite Selection': 'Sélection du client et du site de travail',
  'Add to Equipment': 'Ajouter à l’équipement',
  'Jobsite Inventory': 'Inventaire du site',
  'Equipment SMU at initial Install': 'SMU de l’équipement à l’installation initiale',
  'Implement Definition': 'Définition de l’accessoire',
  'Select Asset Model': 'Sélectionner le modèle de l’actif',
  'Implement Capacity': 'Capacité de l’accessoire',
  'Select GET Type': 'Sélectionner le type de GET',
  'Implement Details': 'Détails de l’accessoire',
  'Implement Serial Number': 'Numéro de série de l’accessoire',
  'Additional Serial #': 'Numéro de série supplémentaire',
  'Implement make': 'Marque de l’accessoire',
  'Implement Budget': 'Budget de l’accessoire',
  'Implement Tons at setup': 'Tonnage de l’accessoire à la configuration',
  'Implement Setup Date and Hours': 'Date et heures de configuration de l’accessoire',
  'Hours on Implement at setup': 'Heures sur l’accessoire lors de la configuration',
  'Implement Cost': 'Coût de l’accessoire',
  'Implement Purchased Cost': 'Coût d’achat de l’accessoire',
  'Save changes & Go To next': 'Enregistrer et continuer',
  'Add implement Image': 'Ajouter une image de l’accessoire',
  'Advanced Implement Copying': 'Copie avancée des accessoires',
  'Source Details': 'Détails de la source',
  'Please select the customer and job site where the EXISTING implement is located': 'Veuillez sélectionner le client et le site où se trouve l’accessoire EXISTANT',
  'Is the EXISTING implement on an equipment, or in inventory ?': 'L’accessoire EXISTANT est-il sur un équipement ou en inventaire ?',
  'Destination Details': 'Détails de destination',
  'Please select the customer and job site where the DESTINATION implement is located': 'Veuillez sélectionner le client et le site où se trouve l’accessoire DESTINATION',
  'Is the DESTINATION implement on an equipment, in inventory or exisiting implement?': 'L’accessoire DESTINATION est-il sur un équipement, en inventaire ou déjà existant ?',
  'Select Implement(s) to be copied': 'Sélectionner l’accessoire à copier',
  'Select Implement': 'Sélectionner l’accessoire',
  'Imp Type:Serial': 'Type Imp : Série',
  'Implement Type': 'Type d’accessoire',
  'New Serial No.': 'Nouveau numéro de série',
  'Equipment SMU at Setup': 'SMU de l’équipement à la configuration',
  'Budget Hours': 'Heures prévues',
  'Purchased Cost': 'Coût d’achat',
  'Copied': 'Copié',
  'Copy Selected': 'Copier la sélection',
  'Modify Asset': 'Modifier l’actif',
  'Add Implement Image': 'Ajouter une image de l’accessoire',
  'Asset Definition Setup': 'Configuration de la définition de l’actif',
  'Input Asset Definition': 'Saisir la définition de l’actif',
  'Input Model #': 'Saisir le modèle #',
  //'Reset': 'Réinitialiser',
  //'Add New': 'Ajouter nouveau',
  'Asset/System Type': 'Type d’actif/système',
  'Asset Definition': 'Définition de l’actif',
  'Model #': 'N° du modèle',
  'PDF Formats to be used': 'Formats PDF à utiliser',
  'Manage Observation Lists': 'Gérer les listes d’observations',
  'Select a Customer': 'Sélectionner un client',
  'Serial/ Unit Search': 'Recherche par N° de série/unité',
  'Stautus': 'Statut',
  'Off-Highway': 'Hors-route',
  'Tempreture Inspections': 'Inspection de température',
  'UC planner': 'Planificateur du train de roulement',
  'Display options': 'Options d’affichage',
  'Coloums': 'Colonnes',
  'Dates': 'Dates',
  'Legend': 'Légende',
  'tasks': 'Tâches',
  'Enter SMU/dates': 'Saisir SMU/Date',
  'Create favorite Generate': 'Créer favori / Générer',
  'February': 'Février',
  'Enter Date for SMU': 'Saisir la date pour le SMU',
  'Favorite': 'Favori',
  'Last Known': 'Dernière lecture connue du SMU ou distance',
  'Enter Date': 'Saisir la date',
  'Enter SMU': 'Saisir SMU',
  'Equipment Serial No/Unit No': 'N° de série ou d’unité de l’équipement',
  'Select All': 'Tout sélectionner',
  'Recommended Action': 'Action recommandée',
  'Oldest Date': 'Date la plus ancienne',
  'Highest Severity': 'Gravité maximale',
  'Earliest SMU': 'Lecture SMU la plus ancienne',
  'Hours Gained': 'Heures gagnées après action',
  'Adjust all staus for equipment': 'Ajuster tous les statuts de l’équipement',
  'Adjust all status for Equip': 'Ajuster tous les statuts de l’équipement',
  'Action Search': 'Recherche d’Action',
  'Favorites': 'Favoris', 'Download': 'Télécharger',
  'Preparing Planner': 'Préparation du Planificateur',
  'Generate': 'Générer',
  'SMU & PMU Service': 'Service SMU & PMU',
  'No data available': 'Aucune donnée disponible',
  'The data will be cleared, are you sure': 'Les données seront effacées, êtes-vous sûr ?',
  'Search O/S UC Action Recommendations': 'Rechercher les Recommandations d’Action O/S UC',
  'Equipment Serial No/UnitNo': 'N° de Série de l’Équipement/N° d’Unité',
  'Action Recommendation date is a future Date, which is not permissible in the Action Taken Screen, the system will use the current Date and Hour meter, please adjust accordingly': 'La date de recommandation d’action est une date future, ce qui n’est pas autorisé dans l’écran Action Effectuée. Le système utilisera la date actuelle et le compteur d’heures, veuillez ajuster en conséquence.',
  'Continue': 'Continuer',
  'Summary': 'Résumé',
  'Hide Favourites': 'Masquer les Favoris',
  'Please use the Search field above to select what equipment you are shown.': 'Veuillez utiliser le champ de recherche ci-dessus pour sélectionner l’équipement à afficher.',
  'Asset Alt. Number': 'Numéro Alternatif de l’Actif',
  'EQUIPMENT VIEW': 'VUE DE L’ÉQUIPEMENT',
  'ASSET VIEW': 'VUE DE L’ACTIF',
  'ASSET LOCATION HISTORY': 'HISTORIQUE DE LOCALISATION DE L’ACTIF',
  'Select Side': 'Sélectionner le côté',
  'Select Unit Number': 'Sélectionner le numéro d’unité',
  'Unit No': 'N° d’unité',
  'Average Projected to 100%': 'Moyenne projetée à 100%',
  'Average Projected to 120%': 'Moyenne projetée à 120%',
  'Average Cost per Hour': 'Moyenne du coût par heure',
  'Usage Distance': 'Distance d’utilisation',
  'per day': 'par jour',
  "SMU Last Known Date": "Date de la Dernière SMU Connue",
  "SMU Last Known SMU": "Dernière SMU Connue",
  "Distance Forward": "Distance Avant",
  "Distance Reverse": "Distance Arrière",
  "Last Dist. Total": "Dernière Distance Totale",
  "Last Known Dist. Date": "Date de la Dernière Distance Connue",
  "Forward Distance": "Distance Avant",
  "Reverse Distance": "Distance Arrière",
  "Total Distance": "Distance Totale",
  "Close PM's": "Fermer les PM",
  "Next Pm Service": "Prochain Service PM",
  "2nd Pm Service": "Deuxième Service PM",
  "Floating Date 1": "Date Flottante 1",
  "Tools & Actions": "Outils et Actions",
  "Display Options": "Options d’Affichage",
  "Enter SMU/Dates": "Saisir SMU/Dates",
  "Last Inspect. Worn %": "% d’Usure à la Dernière Inspection",
  "% Worn <br>Today": "% d’Usure <br>Aujourd’hui",
  "Floating Pm1 Service": "Service PM Flottant 1",
  "Floating Pm2 Service": "Service PM Flottant 2",
  "100 % Worn": "100 % Usé",
  "120 % Worn": "120 % Usé",
  "Start Time": "Heure de Début",
  "Log Sent": "Journal Envoyé",
  "Not Sent": "Non Envoyé",
  "Lab Number": "Numéro de Laboratoire",
  "Sent To Address": "Envoyé à l’Adresse",
  "Please use the Search field above to select what Email Log you are shown.":
    "Veuillez utiliser le champ de recherche ci-dessus pour sélectionner le journal d’e-mails à afficher.",
  'UNDERCARRIAGE': 'TRAIN DE ROULEMENT',
  'Alert Name': 'Nom de l’Alerte',
  'Frequency': 'Fréquence',
  'Enabled': 'Activé',
  'Email Enabled': 'Email Activé',
  'Percentage Worn': 'Pourcentage d’Usure',
  "Planning": "Planification",
  "Setup": "Configuration",
  "Part Search": "Recherche de Pièces",
  "Digital Inspections": "Inspections Numériques",
  "Field Inspection Dashboard": "Tableau de Bord des Inspections sur le Terrain",
  "Get & Wear Surfaces": "GET et Surfaces d’Usure",
  "GET Inspections": "Inspections GET",
  "New GET Inspection": "Nouvelle Inspection GET",
  "Find Inspections": "Rechercher des Inspections",
  "Asset Model Setup": "Configuration du Modèle d’Actif",
  "Document Library": "Bibliothèque de Documents",
  "PIP Setup": "Configuration PIP",
  "Warranty Tracking": "Suivi de Garantie",
  "Observation List Setup": "Configuration de la Liste d’Observation",
  "CRC Dashboard": "Tableau de Bord CRC",
  "Undercarriage": "Train de Roulement",
  "Setup Additional Components": "Configurer des Composants Supplémentaires",
  "Safety": "Sécurité",
  "Dashboards": "Tableaux de Bord",
  "Inductions": "Inductions",
  "Other Inspections": "Autres Inspections",
  "Policies and Procedures": "Politiques et Procédures",
  "Leave": "Congé",
  "HOME - Admin Access": "ACCUEIL - Accès Admin",
  "Safety Dashboard": "Tableau de Bord Sécurité",
  "General Dashboard": "Tableau de Bord Général",
  "Safety Indicators": "Indicateurs de Sécurité",
  "- View/Edit Monthly Hours": "Voir/Modifier les Heures Mensuelles",
  "- Add Monthly Dashboard Message": "Ajouter un Message Mensuel au Tableau de Bord",
  "- Add Toolbox Talk": "Ajouter Toolbox Talk",
  "- Add Take 5s": "Ajouter Take 5",
  "- Setup Forms": "Configurer les Formulaires",
  "Upload Completed Paper Form": "Télécharger le Formulaire Papier Complété",
  "Training Register": "Registre de Formation",
  "Search & Review Forms": "Rechercher et Examiner les Formulaires",
  "Select Form": "Sélectionner le Formulaire",
  "Enter Safety Observation": "Entrer une Observation de Sécurité",
  "Search Safety Observations": "Rechercher des Observations de Sécurité",
  "- Setup Departments/Work Areas": "Configurer les Départements/ Zones de Travail",
  "- Setup Users": "Configurer les Utilisateurs",
  "- Setup Incident Types": "Configurer les Types d’Incident",
  "- Setup Safety Questions": "Configurer les Questions de Sécurité",
  "Perform Induction": "Effectuer une Induction",
  "Search Induction": "Rechercher une Induction",
  "- Setup Induction Types & Sections": "Configurer les Types et Sections d’Induction",
  "- Setup Induction Slides": "Configurer les Diapositives d’Induction",
  "- Setup Induction Questions": "Configurer les Questions d’Induction",
  "Leave Admin": "Administration des Congés",
  'GET Dashboard': 'Tableau de Bord GET',
  'TTadmin': 'Administrateur TT',
  "Action Description & Comment": "Description de l'Action et Commentaire",
  "Old Value": "Ancienne Valeur",
  "New Value": "Nouvelle Valeur",
  "Modified By": "Modifié Par",
  "Audit Trail": "Piste d'Audit",
  "Screen": "Écran",
  'Copy Implement Advanced': 'Copier Implémenter Avancé',
  'Cast': 'Distribution',
  'Unit #': 'Unité #',
  "Number of Observations": "Nombre d’Observations",
  "Components Currently Using": "Composants Actuellement Utilisés",
  "Crack Obs. List": "Liste des Observations de Fissures",
  "Crack Severity List": "Liste de Sévérité des Fissures",
  "Active": "Actif",
  "Setup New List": "Configurer une Nouvelle Liste",
  "List Name": "Nom de la Liste",
  "General Bucket Observations": "Observations Générales du Godet",
  "Add Observation": "Ajouter une Observation",
  "Enter Observation and Press Add": "Entrez l’Observation et Appuyez sur Ajouter",
  "Observation List": "Liste des Observations",
  "Edit Observation List": "Modifier la Liste des Observations",
  "Add/Update": "Ajouter/Mettre à Jour",
  "Observaton": "Observation",
  "There are no observation lists created for this customer. Click Add New to create one.": "Aucune liste d’observations n’a été créée pour ce client. Cliquez sur Ajouter Nouveau pour en créer une.",
  "Existing Implement": "Implément Existant",
  "Implement": "Implément",
  "Selecting Copying of Schematics for Asset": "Sélection de la Copie des Schémas pour l’Actif",
  "Reference Schematics to Originating Templates": "Référencer les Schémas aux Modèles d’Origine",
  "Specific Assets": "Actifs Spécifiques",
  "The Source Implement is not listed as fitting the Model of the Equipment you have selected,": "L’implément source n’est pas listé comme compatible avec le modèle d’équipement sélectionné,",
  "however if you wish to proceed it will be added.": "cependant si vous souhaitez continuer il sera ajouté.",
  "Implement Hours at Setup": "Heures de l’Implément à la Configuration",
  "Implement Serial": "Série de l’Implément",
  "Select Component": "Sélectionner le Composant",
  "Component Name": "Nom du Composant",
  "Part No": "Nº de Pièce",
  "Select Obs. Point": "Sélectionner le Point d’Observation",
  "Observation Point": "Point d’Observation",
  "OP Type": "Type OP",
  "Update Image": "Mettre à Jour l’Image",
  "Delete Image": "Supprimer l’Image",
  "Fabricated": "Fabriqué",
  "Meter Read / SMU": "Lecture du Compteur / SMU",
  "JSON": "JSON",
  "CSV Export": "Exporter CSV",
  "No Data Found - please can reset your selection and try again.": "Aucune donnée trouvée - veuillez réinitialiser votre sélection et réessayer.",
  "Start SMU": "SMU Début",
  "End SMU": "SMU Fin",
  "Start CMU": "CMU Début",
  "End CMU": "CMU Fin",
  "Start Dist": "Distance Début",
  "End Dist": "Distance Fin",
  "Update Selection": "Mettre à jour la sélection",
  "On-Hire Inspection": "Inspection à l’Entrée",
  "Off-Hire Inspection": "Inspection à la Sortie",
  "Left % Used": "% Utilisé Gauche",
  "Right % used": "% Utilisé Droite",
  "Original Cost": "Coût Initial",
  "Leave a comment": "Laisser un commentaire",
  "GET Inspection": "Inspection GET",
  "Get Implement": "Obtenir l’Implément",
  "Digital Forms": "Formulaires Numériques",
  "Equipment SMU at Initial Install": "SMU de l’Équipement à l’Installation Initiale",
  "Implement Make": "Marque de l’Implément",
  "Budget at Setup": "Budget à la Configuration",
  "Implement Tons at Setup": "Tonnes de l’Implément à la Configuration",
  "Hours on Implement at Setup": "Heures de l’Implément à la Configuration",
  "Skip Changes & Go To Next": "Ignorer les Modifications et Passer au Suivant",
  "Save Changes & Go To Next": "Enregistrer les Modifications et Passer au Suivant",
  'System Calculated Usage': 'Utilisation calculée par le système',
  'Manually Entered Usage': 'Utilisation saisie manuellement',
  'Eqiup Unit#': 'N° d’unité d’équipement',
  "Please select an Implement to inspect first!": "Veuillez d'abord sélectionner un équipement à inspecter !",
  "Equipment Smu at Install": "SMU de l'équipement à l'installation",
  "Equipment SMU at Inspection": "SMU de l'équipement à l'inspection",
  "Include Cover Page on report": "Inclure la page de couverture dans le rapport",
  "Include Overall Comment on Report": "Inclure le commentaire général dans le rapport",
  "Work Required": "Travail requis",
  "Job File #": "Numéro de dossier #",
  "Repair Request #": "Numéro de demande de réparation #",
  "Select Schematic to add an observation point/Crack (Click on thumbnail)": "Sélectionnez un schéma pour ajouter un point d'observation/fissure (cliquez sur la miniature)",
  "Part#": "Numéro de pièce #",
  "Wear Limit": "Limite d'usure",
  "Question": "Question",
  "Instructions": "Instructions",
  "Location Name": "Nom de l'emplacement",
  "Obs. List": "Liste des obs.",
  "Severity List": "Liste de sévérité",
  "Incl. Rep.": "Incl. dans le rapp.",
  "Refresh with Asset Type Report Options": "Actualiser avec les options de rapport par type d'actif",
  "ReCalculate Inspection": "Recalculer l'inspection",
  "Inspection Images": "Images d'inspection",
  "Observation Point View": "Vue du point d'observation",
  "Area Inspected": "Zone inspectée",
  "Eng. Evaluation": "Évaluation technique",
  "Addressed To": "Adressé à",
  "Location": "Emplacement",
  "Component Type comment for Report": "Commentaire du type de composant pour le rapport",
  "Report Configuration": "Configuration du rapport",
  "Pre-Inspection Checklist": "Liste de contrôle pré-inspection",
  "Tray Report Configuration": "Configuration du rapport du plateau",
  "Save Report Configuration At Asset Type": "Enregistrer la configuration du rapport pour le type d'actif",
  "Alternate Group Name": "Nom de groupe alternatif",
  "Include in Report Summary": "Inclure dans le résumé du rapport",
  "Include Graph in Summary": "Inclure un graphique dans le résumé",
  "Summary Eval": "Évaluation du résumé",
  "Include Schematic in Summary": "Inclure le schéma dans le résumé",
  "Image Rotation": "Rotation de l'image",
  "Summary Comment": "Commentaire du résumé",
  "Enter a Summary Comment.": "Entrez un commentaire de résumé",
  "Include in Report Body": "Inclure dans le corps du rapport",
  "Include Data Table": "Inclure le tableau de données",
  "Include Graph": "Inclure le graphique",
  "Pie Chart": "Graphique en secteurs",
  "Speedometer Chart": "Graphique de type compteur",
  'Undercarriage Rebuild Centre': 'Centre de reconditionnement de trains de roulement',
  "Start New Undercarriage Rebuild Center": "Démarrer un Nouveau Centre de Reconstruction du Train de Roulement",
  "Find Undercarriage Rebuild Centre": "Trouver un Centre de Reconstruction du Train de Roulement",
  "Frame Undercarriage Rebuild Centre": "Centre de Reconstruction du Train de Roulement (Châssis)",
  "Chain Undercarriage Rebuild Centre": "Centre de Reconstruction du Train de Roulement (Chaîne)",
  "Alerts (Current)": 'Alertes (actuelles)',
  "Source": 'Source',
  "Move to History": 'Déplacer vers l’historique',
  "Alert History": 'Historique des alertes',
  "Move to Current": 'Déplacer vers les actuelles',
  'Selection': 'Sélection',
  'Pass/Fail': 'Réussite/Échec',
  'Yes/No': 'Oui/Non',
  'Reading No.': 'Nº de Lecture',
  'Accepted': 'Accepté',
  'Monitor': 'Surveiller',
  'Not Accepted': 'Non Accepté',
  'Pass': 'Réussite',
  'Fail': 'Échec',
  "NA": "N/A",
  "NO": "Non",
  "YES": "Oui",
  "Enter Equipment Summary Notes...": "Entrez les notes de résumé de l'équipement...",
  "Created On": "Créé le",
  "Summary Notes": "Notes de résumé",
  "Last Modified On": "Dernière modification le",
  "Last Modified By": "Dernière modification par",
  "Edit Summary Notes": "Modifier les notes de résumé",
  "Equipment Summary Notes": "Notes de résumé de l'équipement",
  "DNET Cost": "Coût DNET",
  "Search Result": "Résultat de Recherche",
  "Request New Chain": "Demander une Nouvelle Chaîne",
  "Chain Des": "Description de la Chaîne",
  "Serial Number Start": "Numéro de Série Début",
  "Serial Number End": "Numéro de Série Fin",
  "Pitch": "Pas",
  "# Of Links": "Nb de Maillons",
  "Part Required": "Pièce Requise",
  "Component Description": "Description du Composant",
  "PartLine": "Ligne de Pièce",
  "Quantity Required": "Quantité Requise",
  "Quantity in Stock": "Quantité en Stock",
  "DNET  Cost Each": "Coût Unitaire DNET",
  "DNET  Cost Total": "Coût Total DNET",
  "Add to Part List": "Ajouter à la Liste des Pièces",
  "Request Part List": "Demander une Liste de Pièces",
  "Comments": "Commentaires",
  "Parts": "Pièces",
  "Send Email": "Envoyer un Email",
  "Summary Notes History": "Historique des Notes de Résumé",
  "Request A New Chain": "Demander une Nouvelle Chaîne",
  "Email is required": "L'e-mail est requis",
  "Email is invaild": "L'e-mail n'est pas valide",
  "Model Required": "Modèle Requis",
  "A Model is required": "Un modèle est requis",
  "Make Required": "Marque Requise",
  "A Make is required": "Une marque est requise",
  "Chain Description": "Description de la Chaîne",
  "Edit Favourite": "Modifier le Favori",
  "Update Favourite": "Mettre à Jour le Favori",
  "Form Category": "Catégorie du Formulaire",
  "Select Form Category": "Sélectionner la Catégorie du Formulaire",
  "Machine": "Machine",
  "Select Machine": "Sélectionner la Machine",
  "Form Name": "Nom du Formulaire",
  "Select Form Name": "Sélectionner le Nom du Formulaire",
  "Select Inspector": "Sélectionner l'Inspecteur",
  "Select Custom Date Range": "Sélectionner une Plage de Dates Personnalisée",
  "Not Started": "Non Commencé",
  "In Progress": "En Cours",
  "In Review": "En Révision",
  "Completed": "Terminé",
  "Attention Required": "Attention Requise",
  "Multiple Answers": "Réponses Multiples",
  "Comment Added": "Commentaire Ajouté",
  "Show/Hide": "Afficher/Masquer",
  "SerialNo": "Numéro de Série",
  "UnitNo": "Numéro d’Unité",
  "SMU Difference": "Différence SMU",
  "Serial no": "Numéro de Série",
  "Unit no": "Numéro d’Unité",
  "SMR": "SMR",
  "Fail - Attention Required": "Échec - Attention Requise",
  "False/Unable to Answer - Immediate Action required": "Faux/Impossible de Répondre - Action Immédiate Requise",
  "Report Options": "Options du Rapport",
  "Report Option": "Option du Rapport",
  "Generate PDF": "Générer PDF",
  "In Progress/Completed": "En Cours/Terminé",
  "Available Forms": "Formulaires Disponibles",
  "Linked Models": "Modèles Liés",
  "Linked Customers": "Clients Liés",
  "Start New": "Commencer Nouveau",
  "AVAILABLE FORMS": "FORMULAIRES DISPONIBLES",
  "Create New Form": "Créer un Nouveau Formulaire",
  "Copy": "Copier",
  "Edit Form": "Modifier le Formulaire",
  "Copy Form": "Copier le Formulaire",
  "Select Asset/System Type": "Sélectionner le Type d’Actif/Système",
  "Select Asset Serial Number": "Sélectionner le Numéro de Série de l’Actif",
  "Add Serial Number": "Ajouter un Numéro de Série",
  "Please use the Search field above to select what inspection you are shown.": "Veuillez utiliser le champ de recherche ci-dessus pour sélectionner les inspections à afficher.",
  "Warranty Type Setup": "Configuration du Type de Garantie",
  "Warranty Type": "Type de Garantie",
  "Enter Warranty Type Name": "Entrez le Nom du Type de Garantie",
  "Include": "Inclure",
  "Hours Usage": "Utilisation en Heures",
  "Enter Hours": "Entrez les Heures",
  "Enter Days": "Entrez les Jours",
  "Cycles": "Cycles",
  "Enter Cycles": "Entrez les Cycles",
  "In-Active": "Inactif",
  "Save/Update": "Enregistrer/Mettre à Jour",
  "Product Improvement Program Search": "Recherche du Programme d’Amélioration Produit",
  "Select Build #": "Sélectionner Build #",
  "Serial # Start": "Numéro de Série Début",
  "Enter Serial # Start": "Entrez le Numéro de Série Début",
  "Serial # End": "Numéro de Série Fin",
  "Enter Serial # End": "Entrez le Numéro de Série Fin",
  "PIP Number": "Numéro PIP",
  "Enter Heading": "Entrez le Titre",
  "Enter Heading Placeholder": "Entrez le Titre",
  "Program Start Date": "Date de Début du Programme",
  "Program End Date": "Date de Fin du Programme",
  "PIP#": "PIP#",
  "Heading": "Titre",
  "Built #": "Build #",
  "SN# Start": "SN# Début",
  "SN# End": "SN# Fin",
  "Support Pro.": "Programme Support",
  "Show Less": "Afficher Moins",
  "Show More": "Afficher Plus",
  "Asset SN#": "SN Actif",
  "Unit#": "Unité#",
  "Expired": "Expiré",
  "Product Improvement Program": "Programme d’Amélioration Produit",
  "Return to Search Screen": "Retourner à l’Écran de Recherche",
  "Select Built #": "Sélectionner Build #",
  "Enter PIP Number": "Entrez le Numéro PIP",
  "Enter PIP Description": "Entrez la Description du PIP",
  "Supporting Doc.": "Document de Support",
  "Support Pro Associated with PIP": "Programme de Support Associé au PIP",
  "Support Program Notes": "Notes du Programme de Support",
  "Enter Support Program Notes": "Entrez les Notes du Programme de Support",
  "Generate Alert": "Générer une Alerte",
  "Select Warranty Type": "Sélectionner le Type de Garantie",
  "Select Start Date": "Sélectionner la Date de Début",
  "Enter Starting SMU": "Entrer le SMU Initial",
  "Enter Starting Cycle #": "Entrer le Cycle Initial #",
  "Set Default": "Définir par Défaut",  "Original Warranty": "Garantie Originale",
  "Commencement Date": "Date de Début",
  "Commencement SMU": "SMU Initial",
  "Original CMU": "CMU Original",
  "Residual Warranty": "Garantie Résiduelle",
  "Current Date": "Date Actuelle",
  "Current SMU": "SMU Actuel",
  "Current Cycles": "Cycles Actuels",
  "Approval Request": "Demande d’Approbation",
  "Approval Response": "Réponse d’Approbation",
  "% Complete": "% Complété",
  "Total Hours ": "Total Heures",
  "Total Cost ": "Coût Total",
  "Product Improvement": "Amélioration Produit",
  "PIP No": "Numéro PIP",
  "Completed Date": "Date de Fin",
  "PIP Notes": "Notes PIP",
  "Open": "Ouvert",
  "View Photo": "Voir la Photo",
  "Replace Photo": "Remplacer la Photo",
  "Repairer": "Réparateur",
  "Implement Rebuild's Status": "Statut de Reconstruction de l’Implément",
  "Ready to Rebuild": "Prêt pour Reconstruction",
  "Pre Shipped": "Pré-Expédié",
  "Shipped": "Expédié",
  "Disassembled": "Démonté",
  "SOW-Approvals": "SOW-Approbations",
  "WIP": "Travail en Cours",
  "Ready to Ship": "Prêt à Expédier",
  "Complete": "Terminé",
  "Remove Component From Equipment": "Retirer le Composant de l’Équipement",
  "Create New Component": "Créer un Nouveau Composant",
  "Clear History": "Effacer l’Historique",
  "Make Setup": "Configuration de la Marque",
  "Select Existing Make": "Sélectionner une Marque Existante",
  "Make Details": "Détails de la Marque",
  "Make ID": "ID de la Marque",
  "Enter Make ID": "Entrer l'ID de la Marque",
  "Make Name": "Nom de la Marque",
  "Enter Make Name": "Entrer le Nom de la Marque",
  "Model Search": "Recherche de Modèle",
  "Family Setup": "Configuration de la Famille",
  "Select Existing Family": "Sélectionner une Famille Existante",
  "Family Details": "Détails de la Famille",
  "Family ID": "ID de la Famille",
  "Family Name": "Nom de la Famille",
  "Family Image": "Image de la Famille",
  "Show Distance Travelled Tracking Option on Equipment Setup": "Afficher l’option de suivi de distance parcourue dans la configuration de l’équipement",
  "Show Propel Hours and % on Equipment": "Afficher les heures de propulsion et le % sur l’équipement",
  "Enable Equaliser Bar Type Fields": "Activer les champs du type barre égalisatrice",
  "Enable Track Tension Indicator Installed Fields": "Activer les champs indicateur de tension de chenille",
  "Enable Frame Configuration": "Activer la configuration du châssis",
  "Enable Cannon Type": "Activer le type de canon",
  "Enable Bogie Shim": "Activer la cale bogie",
  "Enable Manual Inspection Pdf": "Activer le PDF d’inspection manuelle",
  "Enable Track Sag": "Activer l’affaissement de chenille",
  "Enable Cannon Extension": "Activer l’extension de canon",
  "Enable Scallop": "Activer scallop",
  "Enable Dry Joints": "Activer les joints secs",
  "Enable # of Links": "Activer le nombre de liens",
  "Enable Under Foot Conditions": "Activer les conditions sous pied",
  "Enable Work Order": "Activer l’ordre de travail",
  "Enable Thermal Image": "Activer l’image thermique",
  "Enable Additional Inspectors": "Activer les inspecteurs supplémentaires",
  "Chain Image": "Image de Chaîne",
  "Choose Chain Image": "Choisir une image de chaîne",
  "Frame Image": "Image du Châssis",
  "Choose Frame Image": "Choisir une image du châssis",
  "Lookup": "Recherche",
  "Job Role": "Rôle Professionnel",
  "Role Name": "Nom du Rôle",
  "Role Notes": "Notes du Rôle",
  "Admin Role": "Rôle Administrateur",
  "Update Roles": "Mettre à Jour les Rôles",
  "Update Permissions": "Mettre à Jour les Permissions",
  "User Name": "Nom d’Utilisateur",
  "Select the model you would like to view/edit": "Sélectionnez le modèle que vous souhaitez afficher/modifier",
  "No data available!": "Aucune donnée disponible !",
  "Model Details": "Détails du Modèle",
  "Model ID": "ID du Modèle",
  "Model Description": "Description du Modèle",
  "Industry": "Industrie",
  "Default Inspection Cycle": "Cycle d’Inspection par Défaut",
  "BaseModel": "Modèle de Base",
  "Model Note": "Note du Modèle",
  "Component Detail": "Détail du Composant",
  "Upload to Mobile": "Télécharger vers Mobile",
  "Chains Available": "Chaînes Disponibles",
  "Add Chain": "Ajouter une Chaîne",
  "# of Links": "# de Liens",
  "No Of Links": "Nombre de Liens",
  "Link Height": "Hauteur du Lien",
  "Number of Idlers": "Nombre de Galets",
  "Bolt Hole Diameter": "Diamètre du Trou de Boulon",
  "Bushing Outside Diameter": "Diamètre Extérieur de la Bague",
  "Number Of CarrierRollers": "Nombre de Rouleaux Porteurs",
  "Chain Spread Inside": "Écartement Intérieur de Chaîne",
  "Chain Spread Outside": "Écartement Extérieur de Chaîne",
  "Number Of TrackRollers": "Nombre de Rouleaux de Chenille",
  "Hardware": "Matériel",
  "Berco Part Number": "Numéro de Pièce Berco",
  "Case Part Number": "Numéro de Pièce Case",
  "Quantity": "Quantité",
  "Part Line": "Ligne de Pièce",
  "Component Details": "Détails du Composant",
  "Component ID": "ID du Composant",
  "Component Type Availability": "Disponibilité du Type de Composant",
  "Observation Details": "Détails de l’Observation",
  "Mobile Screen Display of Observations:": "Affichage mobile des observations :",
  "Equipment Conditions": "Conditions de l’Équipement",
  "Components Screen": "Écran des Composants",
  "Visibility": "Visibilité",
  "Update Limits": "Mettre à Jour les Limites",
  "Admin Role - allows edit functions in the equipment details screen": "Rôle Administrateur - permet les fonctions de modification dans l’écran des détails de l’équipement",
  "Undercarriage Component Types": "Types de Composants du Train de Roulement",
  "Component Image": "Image du Composant",
  "Component Family": "Famille du Composant",
  "Component Type Name": "Nom du Type de Composant",
  "Information": "Information",
  "Please enter component extra details prior to sprocket hardware": "Veuillez saisir les détails supplémentaires du composant avant le matériel du pignon",
  "Ok": "Ok",
  "Undercarriage Worn Limit Management": "Gestion des Limites d’Usure du Train de Roulement",
  "Select Part #": "Sélectionner la Pièce #",
  "Select Tool Used": "Sélectionner l’Outil Utilisé",
  "High Impact": "Impact Élevé",
  "Low Impact": "Faible Impact",
  "Comp. Type": "Type Comp.",
  "Part #": "Pièce #",
  "Method": "Méthode",
  "Tool Used": "Outil Utilisé",
  "Slope": "Pente",
  "Adjust to Base": "Ajuster à la Base",
  "Inflect Pt.": "Point d’Inflexion",
  "Slope1": "Pente1",
  "Y Int.1": "Interception Y1",
  "Slope2": "Pente2",
  "Y Int.2": "Interception Y2",
  "Starting Dim": "Dimension Initiale",
  "100% Worn": "100% Usé",
  "No records to display.": "Aucun enregistrement à afficher.",
  "New High": "Nouveau Haut",
  "New Low": "Nouveau Bas",
  "Polynomial Worn Limits": "Limites d’Usure Polynomiales",
  "Impact 2nd Order": "Impact 2ème Ordre",
  "Normal 2nd Order": "Normal 2ème Ordre",
  "Impact Slope": "Pente d’Impact",
  "Normal Slope": "Pente Normale",
  "Impact Intercept": "Interception d’Impact",
  "Normal Intercept": "Interception Normale",
  "Linear Worn Limits": "Limites d’Usure Linéaires",
  "Worn Limit Setup": "Configuration des Limites d’Usure",
  "Method of Calculation": "Méthode de Calcul",
  "Tools": "Outils",
  "U/C Make": "Marque U/C",
  "Adjustment to Base": "Ajustement à la Base",
  "H.I. - Inflection Point": "H.I. - Point d’Inflexion",
  "M.I. - Inflection Point": "M.I. - Point d’Inflexion",
  "H.I. - Slope 1": "H.I. - Pente 1",
  "M.I. - Slope 1": "M.I. - Pente 1",
  "H.I. -Y Intercept 1": "H.I. - Interception Y 1",
  "M.I. -Y Intercept 1": "M.I. - Interception Y 1",
  "H.I. - Slope 2": "H.I. - Pente 2",
  "M.I. - Slope 2": "M.I. - Pente 2",
  "H.I. -Y Intercept 2": "H.I. - Interception Y 2",
  "M.I. -Y Intercept 2": "M.I. - Interception Y 2",
  "Worn Dimension": "Dimension d’Usure",
  "Impact": "Impact",
  "Start Depth.New": "Profondeur Initiale.Nouvelle",
  "Wear Depth": "Profondeur d’Usure",
  "Normal": "Normal",
  "Slope Direction - Impact": "Direction de Pente - Impact",
  "Slope Direction - Normal": "Direction de Pente - Normal",
  "Add New Limit": "Ajouter Nouvelle Limite",
  "Add Dealer Group Branded Style": "Ajouter un Style de Marque du Groupe de Concessionnaires",
  "Select Dealer Group": "Sélectionner le Groupe de Concessionnaires",
  "Colour Scheme": "Schéma de Couleurs",
  "Select Colour Scheme": "Sélectionner le Schéma de Couleurs",
  "Upload a logo for the Dealer Group. Recommended 77px by 35px.": "Téléchargez un logo pour le Groupe de Concessionnaires. Recommandé : 77px par 35px.",
  "Update Branded Style": "Mettre à Jour le Style de Marque",
  "Worn Spec": "Spécification d’Usure",
  "Tolerance": "Tolérance",
  "Plus": "Plus",
  "Minus": "Moins",
  "Max": "Maximum",
  "Add Measurement Image": "Ajouter une Image de Mesure",
  "Tool Name": "Nom de l’Outil",
  "Currently applying to": "Application actuelle à",
  "selected machines": "machines sélectionnées",
  "For your selection the system is currently using the default ranges. These are shown below": "Pour votre sélection, le système utilise actuellement les plages par défaut. Elles sont affichées ci-dessous",
  "For your selection site default limits display.These are shown below.": "Pour votre sélection, les limites par défaut du site sont affichées ci-dessous.",
  "Limit display for selected machine.": "Affichage des limites pour la machine sélectionnée.",
  "For your selection the system is currently using the dealer ranges. These are shown below": "Pour votre sélection, le système utilise actuellement les plages du concessionnaire. Elles sont affichées ci-dessous",
  "For your selection the system is currently using the customer ranges. These are shown below": "Pour votre sélection, le système utilise actuellement les plages du client. Elles sont affichées ci-dessous",
  "Create New Measurement Point": "Créer un Nouveau Point de Mesure",
  "Rope Shovel/Hydraulic Shovel": "Pelle à Câble/Pelle Hydraulique",
  "URC": "URC",
  "Component Note": "Note du Composant",
  "SMCS Job Code": "Code Travail SMCS",
  "Budget Life (Hours)": "Durée de Vie Prévue (Heures)",
  "Populate from USCO": "Remplir depuis USCO",
  "Component Make": "Marque du Composant",
  "Measurement Images": "Images de Mesure",
  "Unit number": "Numéro d’Unité",
  "Level": "Niveau",
  "Default Tool": "Outil Par Défaut",
  "Select a Default Tool": "Sélectionnez un Outil Par Défaut",
  "Please Select a default tool": "Veuillez sélectionner un outil par défaut",
  "True": "Vrai",
  "False": "Faux",
  "Inspection Type cannot exceed 50 characters.": "Le type d’inspection ne peut pas dépasser 50 caractères.",
  "Standard Cost Repair": "Coût Standard de Réparation",
  "Standard Hours Repair": "Heures Standard de Réparation",
  "You can attach a photo of this measurement point ": "Vous pouvez joindre une photo de ce point de mesure",
  "Add Measurement Points": "Ajouter des Points de Mesure",
  "Copy Obs. Pts.": "Copier les Points Obs.",
  "Select Filters to display and edit data": "Sélectionnez des filtres pour afficher et modifier les données",
  "Component Setup": "Configuration des Composants",
  "Component Search": "Recherche de Composants",
  "Equipment Make": "Marque de l’Équipement",
  "Equipment Model": "Modèle de l’Équipement",
  "Default Tool Used": "Outil Par Défaut Utilisé",
  "Search and Review Forms": "Rechercher et Examiner les Formulaires",
  "Enter Safety Inspection - Web Browser": "Saisir une Inspection de Sécurité - Navigateur Web",
  "Search Safety Inspections": "Rechercher des Inspections de Sécurité",
  "Upload Completed Forms": "Télécharger les Formulaires Complétés",
  "Configuration": "Configuration",
  "Add Take 5's": "Ajouter des Take 5",
  "Add Toolbox Talk": "Ajouter une Discussion Toolbox",
  "Add Monthly Dashboard Message": "Ajouter un Message Mensuel au Tableau de Bord",
  "View/Edit Monthly Hours": "Afficher/Modifier les Heures Mensuelles",
  "Setup Induction Types and Sections": "Configurer les Types et Sections d’Induction",
  "Safety Inspections": "Inspections de Sécurité",
  "Setup Departments/Work Areas": "Configurer les Départements/Zones de Travail",
  "Setup Safety Checklist": "Configurer la Checklist de Sécurité",
  "Setup Digital Forms": "Configurer les Formulaires Numériques",
  "All State": "Tous les États",
  "All States": "Tous les États",
  "Checks Completed": "Contrôles Terminés",
  "Current Count": "Nombre Actuel",
  "Target for Month": "Objectif du Mois",
  "Target for Date": "Objectif pour la Date",
  "Checks with Fails": "Contrôles avec Échecs",
  "Failed Items": "Éléments en Échec",
  "Since Last Fail": "Depuis le Dernier Échec",
  "Incident Counts": "Nombre d’Incidents",
  "Last MTI": "Dernier MTI",
  "Last LTI": "Dernier LTI",
  "Focus Items": "Éléments Prioritaires",
  "Take 5's for Period": "Take 5 pour la Période",
  "Target": "Objectif",
  "Actual": "Réel",
  "Previous 12 Mths Hours": "Heures des 12 Derniers Mois",
  "Previous 12 Mths TRIFR": "TRIFR des 12 Derniers Mois",
  "Last 12 Months": "12 Derniers Mois",
  "Areas of Improvements": "Domaines d’Amélioration",
  "Positives": "Points Positifs",
  "Activities": "Activités",
  "Incidents": "Incidents",
  "Observation Type": "Type d’Observation",
  "Work Area": "Zone de Travail",
  "Office": "Bureau",
  "Month-Year": "Mois-Année",
  "January": "Janvier",
  "March": "Mars",
  "April": "Avril",
  "June": "Juin",
  "July": "Juillet",
  "August": "Août",
  "September": "Septembre",
  "October": "Octobre",
  "November": "Novembre",
  "December": "Décembre",
  "Month": "Mois",
  "Year": "Année",
  "Number": "Nombre",
  "Add New Observation": "Ajouter une Nouvelle Observation",
  "Department": "Département",
  "Task Observed": "Tâche Observée",
  "Setup Departments": "Configurer les Départements",
  "Add Work Area": "Ajouter une Zone de Travail",
  "Add Department": "Ajouter un Département",
  "Incident Types": "Types d’Incident",
  "Add Incident Type": "Ajouter un Type d’Incident",
  "Setup Questions": "Configurer les Questions",
  "Add Question": "Ajouter une Question",
  "Add New Category": "Ajouter une Nouvelle Catégorie",
  "Add Induction Type": "Ajouter un Type d’Induction",
  "Induction Type": "Type d’Induction",
  "Add Slide": "Ajouter une Slide",
  "Safety Observation Search": "Recherche d’Observation de Sécurité",
  "Select Work Area": "Sélectionner une Zone de Travail",
  "Select Category": "Sélectionner une Catégorie",
  "Select Department": "Sélectionner un Département",
  "Select Contractor": "Sélectionner un Prestataire",
  "Select Question": "Sélectionner une Question",
  "Supplier": "Fournisseur",
  "Follow Up Required": "Suivi Requis",
  "Follow Up Completed": "Suivi Terminé",
  "Only Unsafe": "Seulement Dangereux",
  "Exclude N/A": "Exclure N/A",
  "Only Inspections": "Seulement les Inspections",
  "Show Department": "Afficher le Département",
  "Show Work Area": "Afficher la Zone de Travail",
  "Show Observer": "Afficher l’Observateur",
  "Category": "Catégorie",
  "Safe/Unsafe": "Sûr/Dangereux",
  "Unsafe": "Dangereux",
  "Safe": "Sûr",
  "Observer": "Observateur",
  "No Data Found for this search criteria.": "Aucune donnée trouvée pour ce critère de recherche.",
  "Induction": "Induction",
  "Select Induction Type": "Sélectionner un Type d’Induction",
  "Select State": "Sélectionner un État",
  "Facilitator": "Facilitateur",
  "User (Already setup) being Inducted": "Utilisateur (déjà configuré) en induction",
  "User (Not setup) being Inducted": "Utilisateur (non configuré) en induction",
  "Start": "Démarrer",
  "Slide": "Slide",
  "Ans": "Réponse",
  "Issue Start Date": "Date de Début d’Émission",
  "Issue End Date": "Date de Fin d’Émission",
  "Document Heading": "Titre du Document",
  "Date Issued": "Date d’Émission",
  "Expiry Date": "Date d’Expiration",
  "Field Changed": "Champ Modifié",
  "From": "De",
  "To": "À",
  "New Leave Request": "Nouvelle Demande de Congé",
  "Update Leave Request": "Mettre à Jour la Demande de Congé",
  "Leave Requests": "Demandes de Congé",
  "Leave Administration": "Administration des Congés",
  "Leave Type": "Type de Congé",
  "Leave From": "Congé Du",
  "Leave To": "Congé Jusqu’au",
  "Attach Doc.": "Joindre un Document",
  "Attachment": "Pièce Jointe",
  "Administration By": "Administré Par",
  "Approved By": "Approuvé Par",
  "Requested User": "Utilisateur Demandeur",
  "Field Change": "Modification du Champ",
  "Filter user": "Filtrer utilisateur",
  "Filter customer": "Filtrer client",
  "Filter job site": "Filtrer site de travail",
  "Filter dealership": "Filtrer concession",
  "Filter dealer group": "Filtrer groupe de concessions",
  "Pending": "En Attente",
  "Cancel Invite": "Annuler l’Invitation",
  "Support Team Access": "Accès Équipe Support",
  "Dealer Group Access": "Accès Groupe de Concessions",
  "Dealer Access": "Accès Concession",
  "Customer Access": "Accès Client",
  "Jobsite Access": "Accès Site de Travail",
  "Equipment Access": "Accès Équipement",
  "Reset Password": "Réinitialiser le Mot de Passe",
  "Contact Email": "Email de Contact",
  "Job Sites/th": "Sites de Travail",
  "Dealership": "Concession",
  "Dealership Name": "Nom de la Concession",
  "Safety Observation Dashboard": "Tableau de Bord des Observations de Sécurité",
  "Safety General Dashboard": "Tableau de Bord Général de Sécurité",
  "Add Monthly Dashboard Messages": "Ajouter des Messages Mensuels au Tableau de Bord",
  "Select a Form": "Sélectionner un Formulaire",
  "Report / Incident # required": "Rapport / N° d’Incident requis",
  "Digital Form": "Formulaire Numérique",
  "Add Form": "Ajouter un Formulaire",
  "Add Form Category": "Ajouter une Catégorie de Formulaire",
  "Upload Forms": "Télécharger des Formulaires",
  "Add File(s)": "Ajouter des Fichiers",
  "Related User": "Utilisateur Associé",
  "Add Image(s)": "Ajouter des Images",
  "Report/Incident ID": "ID Rapport/Incident",
  "Incident Type": "Type d’Incident",
  "Follow Up Date": "Date de Suivi",
  "Follow Up User": "Utilisateur de Suivi",
  "Form Search": "Recherche de Formulaire",
  "Date Start": "Date de Début",
  "Date End": "Date de Fin",
  "Form": "Formulaire",
  "Person Responsible": "Personne Responsable",
  "Due Date Start": "Date d’Échéance Début",
  "Due Date End": "Date d’Échéance Fin",
  "Suspended User": "Utilisateur Suspendu",
  "Suspended Related Users": "Utilisateurs Associés Suspendus",
  "Archived Forms": "Formulaires Archivés",
  "Active Forms": "Formulaires Actifs",
  "Form Type": "Type de Formulaire",
  "Add to Archive": "Ajouter à l’Archive",
  "All Positions": "Tous les Postes",
  "All Forms": "Tous les Formulaires",
  "All Users": "Tous les Utilisateurs",
  "Date Completed": "Date Terminée",
  "Induction Search": "Recherche d’Intégration",
  "First Name": "Prénom",
  "Last Name": "Nom",
  "Company": "Entreprise",
  "Show Valid": "Afficher les Valides",
  "Show Invalid": "Afficher les Invalides",
  "No Data Found - Please reset and try again.": "Aucune donnée trouvée - veuillez réinitialiser et réessayer.",
  "VALID": "VALIDE",
  "Focus Item": "Élément Principal",
  "Areas Of Improvement": "Axes d’Amélioration",
  "Take 5 target": "Objectif Take 5",
  "Safety Inspection target": "Objectif Inspection Sécurité",
  "Take 5 Target": "Objectif Take 5",
  "Safety Inspection Target": "Objectif Inspection Sécurité",
  "Select Equipment for Hire Report": "Sélectionner l'Équipement pour le Rapport de Location",
  "Idler Setup": "Configuration du Galet",
  "Idler From Inventory": "Galet depuis l'Inventaire",
  "Chain Setup": "Configuration de la Chaîne",
  "Chain From Inventory": "Chaîne depuis l'Inventaire",
  "Frame Setup": "Configuration du Châssis",
  "Frame From Inventory": "Châssis depuis l'Inventaire",
  "Add New Inspection": "Ajouter une Nouvelle Inspection",
  "Additional Component Setup": "Configuration de Composant Supplémentaire",
  "Additional Component Selection": "Sélection de Composant Supplémentaire",
  "Additional Component Details": "Détails du Composant Supplémentaire",
  "Select the component you would like to edit the measurement points for": "Sélectionnez le composant pour lequel vous souhaitez modifier les points de mesure",
  "Model Image": "Image du Modèle",
  "Model Image Left": "Image Gauche du Modèle",
  "Model Image Right": "Image Droite du Modèle",
  "Average wear rates used in Forecasting": "Taux d'usure moyens utilisés pour les prévisions",
  "Base Model": "Modèle de Base",
  "Compart": "Compartiment",
  "Search Document in Library": "Rechercher un Document dans la Bibliothèque",
  "Select Doc. Type": "Sélectionner le Type de Document",
  "Select Doc. Status": "Sélectionner le Statut du Document",
  "Select End Date": "Sélectionner la Date de Fin",
  "Doc. Type": "Type de Document",
  "Add Document in Library": "Ajouter un Document à la Bibliothèque",
  "Edit Document in Library": "Modifier le Document dans la Bibliothèque",
  "Automatically Add to Assets defined by above selection criteria": "Ajouter automatiquement aux actifs définis par les critères de sélection ci-dessus",
  "Additional Component Name": "Nom du Composant Supplémentaire",
  "Select System": "Sélectionner le Système",
  "No System": "Aucun Système",
  "No Side": "Aucun Côté",
  "Please select a Model": "Veuillez sélectionner un Modèle",
  "Apply Models...": "Appliquer aux Modèles...",
  "You can attach a photo.": "Vous pouvez joindre une photo.",
  "JobSite": "Site de Travail",
  "Is Bogie": "Est un Bogie",
  "UC Planner": "Planificateur de Train de Roulement",
  "SMU & PMU Input": "Saisie SMU et PMU",
  "Search URC": "Rechercher URC",
  "New Undercarriage Rebuild Center": "Nouveau Centre de Reconstruction du Train de Roulement",
  "MidPoint %":"Point médian %",
  'Inspection Document Register': 'Registre des Documents d’Inspection',
  'Include in Report (PDFs Only)': 'Inclure dans le Rapport (PDF uniquement)',
  'Attachments': 'Pièces Jointes',
  'Select Date': 'Sélectionner une Date',
  'Select Document Type': 'Sélectionner le Type de Document',
  "Training Center": "Centre de Formation",
  "All Topics": "Tous les Sujets",
  "Filter by Topic": "Filtrer par Sujet",
  "Edit Additional Observation": "Modifier l’Observation Supplémentaire",
  'User Preferences ': 'Préférences Utilisateur',
  "Parts Search": "Recherche de pièces",
  'Report Name': 'Nom du Rapport',
  'Forecast Seasonal Date Ranges': 'Plages de Dates Saisonnières de Prévision',
  "Season": "Saison",
};